import * as React from "react";

function AnimatedWorker(props) {
  return (
    <svg
      className="prefix__animated"
      id="prefix__freepik_stories-app-development"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 750 500"
      {...props}
    >
      <style>
        {
          "@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#prefix__freepik_stories-app-development:not(.prefix__animated) .prefix__animable{opacity:0}"
        }
      </style>
      <g
        id="prefix__freepik--background-complete--inject-259"
        style={{
          transformOrigin: "358.815px 240.745px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          style={{
            transformOrigin: "645.34px 94.44px 0",
          }}
          id="prefix__elkqtex2spfso"
          className="prefix__animable"
          fill="#f5f5f5"
          d="M605.03 55.44h80.62v78h-80.62z"
        />
        <path
          style={{
            transformOrigin: "647.48px 104.56px 0",
          }}
          id="prefix__elbl9c44vxpu"
          className="prefix__animable"
          fill="#ebebeb"
          d="M613.42 124.63l22.3-40.14 18.25 25.66 11.08-13.63 16.49 28.11h-68.12z"
        />
        <path
          d="M661.74 76.68a5.81 5.81 0 11-5.81-5.8 5.81 5.81 0 015.81 5.8z"
          style={{
            transformOrigin: "655.93px 76.6901px 0",
          }}
          id="prefix__el4kq0te105dh"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <path
          d="M679.4 127v-.32-.91-3.51c0-3.09-.05-7.56-.09-13.24 0-11.4-.09-27.62-.16-47.1l.32.33-68.11.05c-.09.08.72-.72.38-.37v65.05l-.34-.33 49.26.17 13.89.09h5.01a.83.83 0 01-.29 0h-4.54l-13.82.09-49.47.17H611V127 96.25 61.91l.39-.39h68.45v.33c-.07 19.57-.12 35.86-.16 47.31 0 5.65-.07 10.09-.09 13.17v4.32a.79.79 0 01-.19.35z"
          style={{
            transformOrigin: "645.42px 94.345px 0",
          }}
          id="prefix__ell6y0ox37rjm"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <path
          style={{
            transformOrigin: "232.07px 407.09px 0",
          }}
          id="prefix__eln8ewzju6hec"
          className="prefix__animable"
          fill="#f5f5f5"
          d="M199.61 375.69h64.92v62.8h-64.92z"
        />
        <path
          style={{
            transformOrigin: "233.795px 415.24px 0",
          }}
          id="prefix__elfhtau8wyre4"
          className="prefix__animable"
          fill="#ebebeb"
          d="M206.37 431.4l17.95-32.32 14.69 20.65 8.93-10.97 13.28 22.64h-54.85z"
        />
        <path
          d="M245.27 392.79a4.67 4.67 0 11-4.67-4.67 4.67 4.67 0 014.67 4.67z"
          style={{
            transformOrigin: "240.6px 392.79px 0",
          }}
          id="prefix__elnit1ikz51xg"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <path
          d="M259.5 433.29a1.33 1.33 0 010-.26v-.73-2.82c0-2.5 0-6.1-.07-10.67 0-9.17-.08-22.24-.14-37.92l.27.26-54.85.05c-.07.06.58-.58.31-.3v52.39l-.27-.27 39.65.14 11.19.07h4.04-3.9l-11.12.07-39.83.14h-.27v-.27-24.76-27.5c-.28.27.37-.39.31-.32h55.11v.27c-.06 15.75-.1 28.87-.13 38.09 0 4.55-.06 8.13-.07 10.6V433.03a1.66 1.66 0 01-.23.26z"
          style={{
            transformOrigin: "232.185px 407.012px 0",
          }}
          id="prefix__elkl3kl9vdyg"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <path
          d="M461.24 274.41a16.34 16.34 0 011.88-3.9l-1.94-3.5 4.94-4.42 3.27 2.33a16.19 16.19 0 014.08-1.43l1.1-3.85 6.62.37.66 3.95a16.27 16.27 0 013.89 1.88l3.51-1.94 4.41 4.94-2.32 3.27a16.26 16.26 0 011.43 4.07l3.85 1.11-.38 6.62-3.94.66a16.66 16.66 0 01-1.88 3.89l1.94 3.51-4.94 4.41-3.27-2.32a16.19 16.19 0 01-4.08 1.43l-1.1 3.85-6.62-.38-.66-3.95a16.49 16.49 0 01-3.9-1.87l-3.5 1.94-4.42-4.94 2.33-3.27a16.19 16.19 0 01-1.43-4.08l-3.85-1.1.37-6.62 3.95-.66zm8.45 4.38a7.11 7.11 0 107.5-6.7 7.1 7.1 0 00-7.5 6.7z"
          style={{
            transformOrigin: "476.77px 279.49px 0",
          }}
          id="prefix__elgsox3wb0mru"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M452.27 197a31.36 31.36 0 016.29-5.52l-.81-7.71 12.15-4.13 4.05 6.61a31.36 31.36 0 018.35.55l4.88-6 11.51 5.68-1.81 7.53a31.54 31.54 0 015.51 6.29l7.72-.81 4.12 12.15-6.61 4.06a31.3 31.3 0 01-.54 8.34l6 4.88-5.67 11.51-7.54-1.81a31.36 31.36 0 01-6.29 5.52l.81 7.71-12.14 4.13-4.06-6.61a31.7 31.7 0 01-8.34-.55l-4.88 6-11.51-5.68 1.8-7.53a31.86 31.86 0 01-5.51-6.29l-7.71.81-4.13-12.15 6.61-4.06a31.72 31.72 0 01.54-8.34l-6-4.88 5.67-11.51 7.54 1.81zM464 211.15a13.76 13.76 0 1018.43-6.26 13.75 13.75 0 00-18.43 6.26z"
          style={{
            transformOrigin: "476.07px 217.81px 0",
          }}
          id="prefix__elfllxohaiebe"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M267.15 93.88a21.09 21.09 0 014.24-3.72l-.55-5.2 8.16-2.78 2.74 4.46a20.89 20.89 0 015.62.36l3.29-4.06 7.76 3.82-1.21 5.09a21.09 21.09 0 013.8 4.24l5.2-.55 2.78 8.19-4.46 2.74a21 21 0 01-.37 5.63l4.07 3.29-3.83 7.76-5.08-1.22a21.65 21.65 0 01-4.24 3.72l.54 5.2-8.19 2.78-2.73-4.46a21.35 21.35 0 01-5.63-.36l-3.29 4.06L268 129l1.22-5.08a20.78 20.78 0 01-3.72-4.24l-5.2.55-2.78-8.19 4.45-2.74a21.42 21.42 0 01.37-5.63l-4.06-3.29 3.82-7.76 5.09 1.22zm7.9 9.57a9.28 9.28 0 1012.43-4.22 9.28 9.28 0 00-12.43 4.22z"
          style={{
            transformOrigin: "283.25px 107.905px 0",
          }}
          id="prefix__el16a6e5xlbc0i"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M465 59.78a29.94 29.94 0 016.09-5.34l-.83-7.44L482 43l3.93 6.4a30.5 30.5 0 018.07.52l4.73-5.83 11.14 5.49-1.75 7.3a30.16 30.16 0 015.35 6.12l7.47-.79 4 11.76-6.39 3.93a30.61 30.61 0 01-.53 8.08l5.83 4.72-5.49 11.14-7.3-1.75a30.47 30.47 0 01-6.08 5.34l.78 7.46-11.76 4-3.92-6.4a30.58 30.58 0 01-8.08-.53l-4.72 5.83-11.14-5.49 1.75-7.29a30.48 30.48 0 01-5.34-6.09l-7.47.78-4-11.76 6.4-3.92a30.16 30.16 0 01.52-8.08l-5.83-4.72L457.66 58l7.3 1.75zm11.35 13.73a13.32 13.32 0 1017.84-6.06 13.32 13.32 0 00-17.88 6.06z"
          style={{
            transformOrigin: "488.01px 79.945px 0",
          }}
          id="prefix__elvilc1a5tiwe"
          className="prefix__animable"
          fill="#f5f5f5"
        />
        <path
          d="M149.06 81.79a18.76 18.76 0 0011.17-17.35c0-10.36-7.8-18.79-17.51-18.84s-17.62 8.32-17.66 18.68a18.71 18.71 0 0011.2 17.51c-27.06 4.08-25.83 33.49-25.83 33.49l64 .3s1.46-29.74-25.37-33.79z"
          style={{
            transformOrigin: "142.433px 80.5899px 0",
          }}
          id="prefix__elwmci8w8j35j"
          className="prefix__animable"
          fill="#f5f5f5"
        />
        <circle
          cx={40.32}
          cy={263.93}
          r={8.34}
          style={{
            transformOrigin: "40.32px 263.93px 0",
          }}
          className="prefix__animable"
          fill="#ebebeb"
          transform="rotate(-89.2)"
          id="prefix__elvncm4mrzato"
        />
        <circle
          cx={63.66}
          cy={247.22}
          r={8.34}
          style={{
            transformOrigin: "63.66px 247.22px 0",
          }}
          id="prefix__eldkam5qf65da"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <ellipse
          cx={63.71}
          cy={282.57}
          rx={8.34}
          ry={9.08}
          style={{
            transformOrigin: "63.71px 282.57px 0",
          }}
          className="prefix__animable"
          fill="#ebebeb"
          transform="rotate(-.08)"
          id="prefix__elpe3oydrafvl"
        />
        <path
          d="M61.25 281.5c-.36.53-5.91-2.62-12.39-7s-11.46-8.42-11.1-8.94 5.9 2.62 12.39 7 11.46 8.44 11.1 8.94z"
          style={{
            transformOrigin: "49.505px 273.531px 0",
          }}
          id="prefix__elbmi6t9zsh19"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <path
          d="M61.92 246.63c.38.5-3.9 4.47-9.57 8.87s-10.59 7.55-11 7.05 3.9-4.47 9.57-8.87 10.61-7.55 11-7.05z"
          style={{
            transformOrigin: "51.6332px 254.59px 0",
          }}
          id="prefix__elag38wkmqppe"
          className="prefix__animable"
          fill="#ebebeb"
        />
      </g>
      <g
        id="prefix__freepik--Table--inject-259"
        style={{
          transformOrigin: "375.03px 457.235px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable prefix__animator-active"
      >
        <path
          d="M713 457.21c0 .14-151.32.26-337.94.26s-338-.12-338-.26S188.33 457 375 457s338 .07 338 .21z"
          style={{
            transformOrigin: "375.03px 457.235px 0",
          }}
          id="prefix__el5rzhonku7nx"
          className="prefix__animable"
          fill="#263238"
        />
      </g>
      <g
        id="prefix__freepik--Gear--inject-259"
        style={{
          transformOrigin: "480.475px 329.135px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          d="M461.65 313.07a24.77 24.77 0 014.86-4.36l-.71-6 9.43-3.34 3.23 5.12a24.19 24.19 0 016.51.34l3.75-4.75 9 4.31-1.33 5.9a24.72 24.72 0 014.36 4.85l6-.71 3.33 9.44-5.08 3.22a24.61 24.61 0 01-.34 6.51l4.74 3.75-4.31 9-5.88-1.35a24.51 24.51 0 01-4.86 4.37l.71 6-9.43 3.34-3.23-5.11a24.62 24.62 0 01-6.51-.35l-3.75 4.75-9-4.31 1.33-5.9a24.44 24.44 0 01-4.36-4.85l-6 .71-3.33-9.43 5.11-3.23a24.68 24.68 0 01.34-6.52l-4.74-3.74 4.31-9 5.89 1.33zm9.29 10.93a10.73 10.73 0 1014.31-5 10.73 10.73 0 00-14.31 5z"
          style={{
            transformOrigin: "480.43px 329.04px 0",
          }}
          id="prefix__elswgx3yzmu2"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M461.65 313.07a24.77 24.77 0 014.86-4.36l-.71-6 9.43-3.34 3.23 5.12a24.19 24.19 0 016.51.34l3.75-4.75 9 4.31-1.33 5.9a24.72 24.72 0 014.36 4.85l6-.71 3.33 9.44-5.08 3.22a24.61 24.61 0 01-.34 6.51l4.74 3.75-4.31 9-5.88-1.35a24.51 24.51 0 01-4.86 4.37l.71 6-9.43 3.34-3.23-5.11a24.62 24.62 0 01-6.51-.35l-3.75 4.75-9-4.31 1.33-5.9a24.44 24.44 0 01-4.36-4.85l-6 .71-3.33-9.43 5.11-3.23a24.68 24.68 0 01.34-6.52l-4.74-3.74 4.31-9 5.89 1.33zm9.29 10.93a10.73 10.73 0 1014.31-5 10.73 10.73 0 00-14.31 5z"
          style={{
            transformOrigin: "480.43px 329.04px 0",
          }}
          id="prefix__eltcef4r4psd"
          className="prefix__animable"
          fill="none"
        />
        <path
          d="M470.94 324a8.24 8.24 0 011.35-2.28 10.64 10.64 0 016.11-3.72 10.79 10.79 0 015 .1 11 11 0 015 2.88 11 11 0 013 5.65 10.91 10.91 0 01-5.59 11.72 10.33 10.33 0 01-3.11 1.1 10.17 10.17 0 01-3.15.14 10.89 10.89 0 01-5.39-2.08 10.8 10.8 0 01-4.16-11 8.19 8.19 0 01.93-2.49 20.62 20.62 0 00-.73 2.53 10.7 10.7 0 001 6.91 10.53 10.53 0 008.36 5.62 9.88 9.88 0 003-.15 9.76 9.76 0 002.95-1.06 10.43 10.43 0 005.34-11.18 9.92 9.92 0 00-1-3 9.49 9.49 0 00-1.77-2.44 10.55 10.55 0 00-4.78-2.8 10.39 10.39 0 00-4.84-.16 10.68 10.68 0 00-6 3.54 22.59 22.59 0 00-1.52 2.17z"
          style={{
            transformOrigin: "480.677px 328.704px 0",
          }}
          id="prefix__elvtdgge4pvga"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M461.65 313.07l-.37-.06-1.12-.24-4.42-.95.09-.05c-1.09 2.32-2.53 5.36-4.26 9.05v-.16l4.76 3.73.07.06v.09a24.49 24.49 0 00-.4 6.46v.11l-.09.05-5.1 3.24.07-.22 3.36 9.43-.22-.13 6-.72h.12l.08.11a24.13 24.13 0 004.33 4.8l.1.09v.13l-1.32 5.9-.13-.26 9 4.3-.29.07 3.74-4.75.09-.12h.15a24 24 0 006.45.33h.15l.08.13c1 1.6 2.12 3.35 3.23 5.11l-.3-.1 9.44-3.34-.17.27c-.23-1.89-.47-3.94-.71-6v-.16l.13-.09a24.15 24.15 0 004.79-4.31l.1-.12h.15l5.9 1.33-.29.15q2.17-4.57 4.31-9l.07.31-4.74-3.75-.12-.09v-.16a24.51 24.51 0 00.34-6.44v-.16l.13-.08 5.12-3.22-.1.29q-1.71-4.83-3.33-9.44l.25.16-6 .7h-.14l-.08-.12a24.61 24.61 0 00-4.32-4.81l-.1-.09v-.13c.46-2 .9-4 1.34-5.89l.12.24-9-4.33.25-.05-3.76 4.74-.07.08h-.11a24.35 24.35 0 00-6.47-.35h-.1l-.06-.09-3.21-5.12.18.06-9.44 3.3.07-.12c.27 2.4.49 4.37.68 6v.05a25.48 25.48 0 00-3.78 3.12l-.84.88c-.18.2-.28.29-.28.29l.25-.32c.18-.2.44-.51.81-.91a23.94 23.94 0 013.75-3.2v.08c-.2-1.64-.44-3.61-.74-6v-.09h.09l9.42-3.37h.12l.06.1c1 1.58 2.07 3.25 3.24 5.11l-.15-.08a24.6 24.6 0 016.56.33l-.18.06 3.73-4.75.1-.13.15.07 9 4.3.16.07v.17l-1.32 5.9-.08-.22A24.62 24.62 0 01501 315l-.22-.1 6-.71h.19l.06.18 3.35 9.44.06.18-.16.11-5.12 3.23.12-.23a24.71 24.71 0 01-.34 6.58l-.09-.25 4.74 3.74.16.13-.08.19q-2.13 4.46-4.31 9l-.09.19-.2-.05-5.9-1.33.25-.09a25.22 25.22 0 01-4.9 4.4l.11-.24c.25 2.06.49 4.11.71 6v.21l-.19.07-9.44 3.35-.19.07-.11-.17-3.22-5.12.23.12a25.37 25.37 0 01-6.58-.35l.24-.09-3.75 4.74-.12.15-.17-.08-9-4.32-.17-.08v-.18c.47-2.05.93-4.07 1.34-5.9l.08.22a24.42 24.42 0 01-4.4-4.9l.21.1-6 .69h-.17l-.05-.15q-1.74-5-3.32-9.44l-.05-.14.13-.08 5.12-3.22-.08.16a25.11 25.11 0 01.36-6.56l.06.15-4.74-3.76-.08-.07.05-.09 4.35-9v-.06h.07l4.36 1 1.13.27z"
          style={{
            transformOrigin: "480.475px 329.135px 0",
          }}
          id="prefix__elagvncuj23gb"
          className="prefix__animable"
          fill="#263238"
        />
      </g>
      <g
        id="prefix__freepik--Screen--inject-259"
        style={{
          transformOrigin: "381.615px 267.65px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          d="M451.36 78.65l-26.75-.13a6.65 6.65 0 00-6.52 6.74v4.84a6.64 6.64 0 01-6.52 6.74l-52.13-.24a6.64 6.64 0 01-6.44-6.8V85a6.63 6.63 0 00-6.46-6.79h-9.41L313.69 78a21 21 0 00-21.14 20.9l-1.42 336.6a21 21 0 0020.94 21.08l137.66.63a21 21 0 0021.14-20.9l1.43-336.59a21 21 0 00-20.94-21.07z"
          style={{
            transformOrigin: "381.715px 267.605px 0",
          }}
          id="prefix__el1avbx80c8if"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M451.36 78.65h.71a16.21 16.21 0 012.13.18 19.78 19.78 0 017.87 2.74 20 20 0 014.78 3.89 21 21 0 014 6.28 21.71 21.71 0 011.55 8.52v9.91c-.1 28-.25 68.47-.42 118.5s-.43 109.6-.69 175.75q-.06 12.39-.1 25.1v6.37a21.1 21.1 0 01-8.15 17 20.77 20.77 0 01-5.73 3.19 23.05 23.05 0 01-3.17.93 22.69 22.69 0 01-3.29.37c-4.39.09-8.77 0-13.19 0l-26.75-.13-54.9-.24-28.07-.13-14.18-.07A22.27 22.27 0 01300 453a21.47 21.47 0 01-8.3-11.48 23.12 23.12 0 01-.86-7.1v-7.08l.12-28.09q.12-27.89.24-54.91c.16-36 .31-70.72.45-103.8s.29-64.51.43-93.93q.09-22.07.19-42.57v-5.09c.05-.85.06-1.7.16-2.54A19 19 0 01293 94a20.85 20.85 0 014.56-8.8 21.84 21.84 0 017.87-5.7c.77-.26 1.51-.58 2.28-.78a19.41 19.41 0 012.35-.53 17.16 17.16 0 012.37-.25c.79 0 1.58-.07 2.36-.06l18.31.1H346.22a6.57 6.57 0 014.09 1.26 6.9 6.9 0 012.47 3.43 12.43 12.43 0 01.36 4.14v2a12 12 0 00.09 2 6.59 6.59 0 001.64 3.49 6.36 6.36 0 003.27 1.93 8.65 8.65 0 001.91.15h9.53l27.7.15 12.21.07h2.86a6.3 6.3 0 002.57-.92 6.65 6.65 0 002.94-4.25A12.1 12.1 0 00418 89v-2.51a12.51 12.51 0 01.13-2.45 7.16 7.16 0 01.82-2.24 6.62 6.62 0 013.39-2.91 10.88 10.88 0 014.17-.4l13.62.08 8.38.07h2.86H426.5a10.88 10.88 0 00-4.11.41 6.4 6.4 0 00-3.29 2.84 7 7 0 00-.8 2.18 12.88 12.88 0 00-.12 2.42V89a12.79 12.79 0 01-.16 2.6A6.88 6.88 0 01415 96a6.44 6.44 0 01-2.67 1c-1 .1-1.91 0-2.89 0h-12.21l-27.69-.11H360a9.41 9.41 0 01-2-.16 6.67 6.67 0 01-3.43-2 7 7 0 01-1.73-3.65 11.8 11.8 0 01-.08-2.05v-2a11.85 11.85 0 00-.34-4 6.59 6.59 0 00-2.36-3.27 6.23 6.23 0 00-3.89-1.19h-13.13l-18.3-.08c-.79 0-1.57 0-2.34.06a16.44 16.44 0 00-2.33.25 20.12 20.12 0 00-2.3.52c-.76.2-1.49.52-2.24.77a21.51 21.51 0 00-7.73 5.6 20.52 20.52 0 00-4.47 8.65c-.87 3.21-.56 6.63-.64 10q-.08 20.47-.16 42.56c-.12 29.42-.24 60.85-.38 93.93s-.27 67.81-.42 103.81q-.12 27-.23 54.9l-.12 28.09v7.08a22.92 22.92 0 00.84 7 21 21 0 008.1 11.21 21.74 21.74 0 0013.36 3.7l14.18.07 28.08.13 54.89.25 26.75.13c4.41 0 8.82.09 13.17 0a23 23 0 003.21-.36 23.47 23.47 0 003.1-.91 20.16 20.16 0 005.59-3.11 20.45 20.45 0 007.09-10.37c1.27-4.07.78-8.4.91-12.62q0-12.71.11-25.11c.3-66.14.57-125.71.8-175.75s.45-90.51.58-118.5c0-3.49 0-6.8.06-9.9a21.4 21.4 0 00-1.51-8.46 20.94 20.94 0 00-3.94-6.25 21 21 0 00-12.55-6.96 17 17 0 00-2.13-.2z"
          style={{
            transformOrigin: "381.615px 267.65px 0",
          }}
          id="prefix__el24i05fmjsyw"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M427.9 437.91l.8-.07 1-.06 1.34-.22a17 17 0 008.06-3.83 17.62 17.62 0 004.09-5 17.45 17.45 0 002.05-7.38c.07-2.77.18-5.82-.9-8.79a17.11 17.11 0 00-2.17-4.31 18.09 18.09 0 00-3.47-3.7 17 17 0 00-4.63-2.62 19.6 19.6 0 00-2.64-.79 20 20 0 00-2.8-.32c-3.82-.06-7.83 0-12 0h-86.95a17.29 17.29 0 00-16.85 13.51c-.15.61-.21 1.25-.32 1.87s-.07 1.26-.11 1.89c0 1.28 0 2.55.08 3.79a17.28 17.28 0 0013.43 15.34 31.27 31.27 0 007 .43l49.44.06 33.33.08 9.06.05h3.16-3.16l-9.06.05-33.33.08-49.44.06a31.46 31.46 0 01-7.08-.43A17.81 17.81 0 01312 421.94c-.09-1.29-.08-2.56-.08-3.83 0-.65.05-1.3.11-1.94s.17-1.3.32-1.93a17.81 17.81 0 0117.36-13.92h86.95c4.14 0 8.12 0 12 .05a19.4 19.4 0 012.87.34 19.1 19.1 0 012.7.81 17.69 17.69 0 014.72 2.69 18.29 18.29 0 013.53 3.79 17.77 17.77 0 012.2 4.4 23.66 23.66 0 01.87 8.91 17.48 17.48 0 01-6.3 12.54 19.31 19.31 0 01-4.48 2.72 19 19 0 01-3.69 1.06l-1.36.19h-1z"
          style={{
            transformOrigin: "378.786px 419.197px 0",
          }}
          id="prefix__el2sf9z2uscsq"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M447.81 369.53v-.56-1.62-6.28c0-5.5 0-13.54-.06-23.76 0-20.42-.07-49.53-.12-84.32l.23.23H342.05l.26-.26V369.5l-.22-.22 76.71.11 21.48.06h7.67-7.54l-21.43.06-76.85.11h-.23v-.22V252.6H448v.4l-.12 84.46c0 10.2 0 18.23-.06 23.71v7.84c0 .37-.01.52-.01.52z"
          style={{
            transformOrigin: "394.95px 311.11px 0",
          }}
          id="prefix__elnrnnrsu98vl"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M413.37 133.6c0 .15-13.15.26-29.37.26s-29.38-.11-29.38-.26 13.15-.26 29.38-.26 29.37.12 29.37.26z"
          style={{
            transformOrigin: "383.995px 133.6px 0",
          }}
          id="prefix__elhrfait58e5s"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M451.87 127.73a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            transformOrigin: "450.13px 127.74px 0",
          }}
          id="prefix__eli2nfii6kofd"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M451.87 133.09a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            transformOrigin: "450.13px 133.1px 0",
          }}
          id="prefix__elq6ep09hdia"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M451.87 138.45a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            transformOrigin: "450.13px 138.46px 0",
          }}
          id="prefix__elj5n95y4c5za"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M379.6 237.68v-.33-.94-3.64c0-3.19 0-7.85-.06-13.77 0-11.83-.07-28.71-.11-48.95l.22.22h-67.62l.26-.26v67.63l-.22-.23 49 .12 13.76.06h4.59-4.49l-13.72.06-49.1.11h-.23v-.23-67.89H379.85v.23l-.12 49.1c0 5.89 0 10.53-.06 13.71V237.2c0 .22-.07.48-.07.48z"
          style={{
            transformOrigin: "345.865px 203.7px 0",
          }}
          id="prefix__eld07f17hbi2q"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M379.38 170.36a1.2 1.2 0 01-.15.2l-.47.54-1.85 2c-1.62 1.77-4 4.31-6.92 7.42-5.88 6.22-14.11 14.72-23.39 23.91s-17.86 17.34-24.14 23.16c-3.14 2.91-5.7 5.25-7.48 6.85l-2.06 1.83-.54.47a.94.94 0 01-.2.14.87.87 0 01.16-.18l.51-.51 2-1.9 7.37-7c6.21-5.88 14.74-14.07 24-23.26s17.55-17.64 23.49-23.8l7-7.3 1.92-2 .51-.51z"
          style={{
            transformOrigin: "345.78px 203.62px 0",
          }}
          id="prefix__eld8vx51ougd"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M379.6 237.68c-.1.1-15.32-15-34-33.63s-33.73-33.9-33.63-34 15.32 14.95 34 33.63 33.73 33.9 33.63 34z"
          style={{
            transformOrigin: "345.785px 203.865px 0",
          }}
          id="prefix__el9w965xrvpf"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M446.39 184.86v-.92-2.61c0-2.29 0-5.59-.08-9.75l.15.15-56.82.11.26-.26v13.26l-.26-.26 40.47.12 12 .07h4.08a1.85 1.85 0 01.3 0 1.1 1.1 0 01-.26 0h-4l-11.92.07-40.65.12h-.25v-.26-13.1l.26-.26 56.82.11h.15v.15c0 4.2-.06 7.52-.08 9.84v3.23c0 .17-.16.2-.17.19z"
          style={{
            transformOrigin: "418.025px 178.15px 0",
          }}
          id="prefix__elgvpqc9r7otb"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M454.92 200.37c0 .14-14.23.26-31.77.26s-31.79-.12-31.79-.26 14.23-.26 31.79-.26 31.77.12 31.77.26z"
          style={{
            transformOrigin: "423.14px 200.37px 0",
          }}
          id="prefix__el1lcfilupiyc"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M454.92 207.36c0 .14-14.23.26-31.77.26s-31.79-.12-31.79-.26 14.23-.26 31.79-.26 31.77.11 31.77.26z"
          style={{
            transformOrigin: "423.14px 207.36px 0",
          }}
          id="prefix__el8r93nbu5xyk"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M454.92 214.34c0 .14-14.23.26-31.77.26s-31.79-.12-31.79-.26 14.23-.26 31.79-.26 31.77.12 31.77.26z"
          style={{
            transformOrigin: "423.14px 214.34px 0",
          }}
          id="prefix__elocho5xa3n6q"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M454.92 221.32c0 .15-14.23.26-31.77.26s-31.79-.11-31.79-.26 14.23-.26 31.79-.26 31.77.12 31.77.26z"
          style={{
            transformOrigin: "423.14px 221.32px 0",
          }}
          id="prefix__ellzwa7b9ber"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M454.92 228.31c0 .14-14.23.26-31.77.26s-31.79-.12-31.79-.26 14.23-.26 31.79-.26 31.77.12 31.77.26z"
          style={{
            transformOrigin: "423.14px 228.31px 0",
          }}
          id="prefix__elt2npd45i59"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M454.92 235.29c0 .15-14.23.26-31.77.26s-31.79-.11-31.79-.26 14.23-.26 31.79-.26 31.77.12 31.77.26z"
          style={{
            transformOrigin: "423.14px 235.29px 0",
          }}
          id="prefix__el01n32aazlzmo"
          className="prefix__animable"
          fill="#263238"
        />
      </g>
      <g
        id="prefix__freepik--Icons--inject-259"
        style={{
          transformOrigin: "384.45px 132.89px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          d="M516.5 155a2.68 2.68 0 11-2.68-2.68 2.68 2.68 0 012.68 2.68z"
          style={{
            transformOrigin: "513.82px 155px 0",
          }}
          id="prefix__el0wametnb9a1o"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M513.82 155.51h-9A14.84 14.84 0 01490 140.68c0-5.36-.36-8.82-5.15-8.82h-12.69v-1h12.68c6.15 0 6.15 5.18 6.15 9.75a13.86 13.86 0 0013.83 13.9h9z"
          style={{
            transformOrigin: "492.99px 143.185px 0",
          }}
          id="prefix__elnobxmyiltf"
          className="prefix__animable"
          fill="#263238"
        />
        <rect
          x={193.38}
          y={115.58}
          width={55.87}
          height={55.87}
          rx={11.78}
          style={{
            transformOrigin: "221.315px 143.515px 0",
          }}
          id="prefix__elsm28t9x9k8"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M212.93 155.12h5.91a.63.63 0 00.63-.62v-6.23a.63.63 0 01.63-.63h4.21a.63.63 0 01.63.63v6.36a.63.63 0 00.63.63h5.87a.63.63 0 00.63-.63v-11.37a.64.64 0 00-.19-.46l-9.28-8.92a.61.61 0 00-.86 0l-9.27 8.7a.6.6 0 00-.2.46v11.47a.63.63 0 00.66.61z"
          style={{
            transformOrigin: "222.17px 144.481px 0",
          }}
          id="prefix__elpd2amrvj59h"
          className="prefix__animable"
          fill="#fff"
        />
        <rect
          x={525.7}
          y={127.39}
          width={49.82}
          height={49.82}
          rx={11.78}
          style={{
            transformOrigin: "550.61px 152.3px 0",
          }}
          id="prefix__elr1j0sboli8"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          style={{
            transformOrigin: "551.185px 148.23px 0",
          }}
          id="prefix__el5a0e7043xv7"
          className="prefix__animable"
          fill="#fff"
          d="M542.46 147.23h17.45v2h-17.45z"
        />
        <path
          style={{
            transformOrigin: "551.185px 152.65px 0",
          }}
          id="prefix__elnah4k1qjeoi"
          className="prefix__animable"
          fill="#fff"
          d="M542.46 151.65h17.45v2h-17.45z"
        />
        <path
          style={{
            transformOrigin: "551.185px 157.08px 0",
          }}
          id="prefix__el8ux72n0p1hf"
          className="prefix__animable"
          fill="#fff"
          d="M542.46 156.08h17.45v2h-17.45z"
        />
        <path
          d="M225.74 107.19a2.68 2.68 0 11-2.68-2.68 2.68 2.68 0 012.68 2.68z"
          style={{
            transformOrigin: "223.06px 107.19px 0",
          }}
          id="prefix__elfk5p2s677t"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M384.35 79.35a2.68 2.68 0 11-2.68-2.68 2.68 2.68 0 012.68 2.68z"
          style={{
            transformOrigin: "381.67px 79.35px 0",
          }}
          id="prefix__elpa21yn06did"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M223.56 106.1h-1V74.15a14.75 14.75 0 0114.73-14.73h130.24a14.75 14.75 0 0114.73 14.73v5.2h-1v-5.2a13.75 13.75 0 00-13.73-13.73H237.29a13.75 13.75 0 00-13.73 13.73z"
          style={{
            transformOrigin: "302.41px 82.76px 0",
          }}
          id="prefix__elck8mdlgzbjw"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M307.72 203.71A2.68 2.68 0 11305 201a2.68 2.68 0 012.72 2.71z"
          style={{
            transformOrigin: "305.04px 203.68px 0",
          }}
          id="prefix__el69ppiz0z3p7"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M305.31 204.36h-26.08a8 8 0 01-8-8V151a8 8 0 018-8h13.14v1h-13.14a7 7 0 00-7 7v45.44a7 7 0 007 7h26.08z"
          style={{
            transformOrigin: "288.27px 173.68px 0",
          }}
          id="prefix__elgj5l9jwbhe5"
          className="prefix__animable"
          fill="#263238"
        />
      </g>
      <g
        id="prefix__freepik--speech-bubble-2--inject-259"
        style={{
          transformOrigin: "670.259px 156.314px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          d="M634.63 186.53l4.06-10.87a37 37 0 118.87 9.87z"
          style={{
            transformOrigin: "670.197px 156.264px 0",
          }}
          id="prefix__el9jmk0am5v68"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M634.63 186.53l.86-.08 2.49-.22 9.58-.8-.08.19a.11.11 0 010-.16.12.12 0 01.14 0 37 37 0 0016.73 7.19 34.89 34.89 0 005.69.45 40.07 40.07 0 006.07-.53 36.72 36.72 0 007.38-70.44 37.48 37.48 0 00-16.74-2.36 36.25 36.25 0 00-15.14 4.89 37 37 0 00-16.86 21.88l-.39 1.53a9.78 9.78 0 00-.32 1.52c-.16 1-.31 2-.47 3a53 53 0 00-.14 5.73 36.88 36.88 0 005.34 17.32.1.1 0 010 .09l-3.07 8-.8 2.08c-.18.47-.29.72-.29.72s.07-.23.24-.69.42-1.17.75-2.07l3-8.14v.09a36.87 36.87 0 01-5.49-17.41 51.53 51.53 0 01.12-5.79l.45-3A10.28 10.28 0 01634 148c.13-.51.26-1 .4-1.54a37.17 37.17 0 0117-22.19 36.65 36.65 0 0115.34-5 37.88 37.88 0 0117 2.38 37 37 0 0114.6 10.35 16.86 16.86 0 011.41 1.75l1.34 1.8 1.16 1.91a14.78 14.78 0 011.07 1.95c.33.66.65 1.33 1 2a21.22 21.22 0 01.8 2.05c.24.69.53 1.36.73 2.06l.54 2.11a36.66 36.66 0 01.15 16.79A37.14 37.14 0 01676.18 193a42.13 42.13 0 01-6.14.51 37.63 37.63 0 01-5.73-.48 37 37 0 01-16.82-7.36l.16-.16a.11.11 0 010 .16h-.06l-9.68.67-2.46.16z"
          style={{
            transformOrigin: "670.259px 156.314px 0",
          }}
          id="prefix__el8a0gnos2bq4"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          style={{
            transformOrigin: "669.505px 156.5px 0",
          }}
          id="prefix__elf585f8xxyzw"
          className="prefix__animable"
          fill="#263238"
          d="M672.29 166.94l-19.11-7.21.36-.93 18.36 6.93 13.1-19.67.83.56-13.54 20.32z"
        />
        <circle
          cx={653.36}
          cy={158.88}
          r={3.94}
          style={{
            transformOrigin: "653.36px 158.88px 0",
          }}
          id="prefix__eluq5oh69u2na"
          className="prefix__animable"
          fill="#455a64"
        />
        <circle
          cx={672.1}
          cy={166.34}
          r={3.94}
          style={{
            transformOrigin: "672.1px 166.34px 0",
          }}
          id="prefix__el6zchlosmo5a"
          className="prefix__animable"
          fill="#455a64"
        />
        <circle
          cx={685.41}
          cy={146.34}
          r={3.94}
          style={{
            transformOrigin: "685.41px 146.34px 0",
          }}
          id="prefix__elz3aty6xs8o8"
          className="prefix__animable"
          fill="#455a64"
        />
      </g>
      <g
        id="prefix__freepik--speech-bubble-1--inject-259"
        style={{
          transformOrigin: "67.4181px 185.77px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          d="M97.9 221.68l-11-4.09a37.33 37.33 0 1110-8.94z"
          style={{
            transformOrigin: "67.4246px 185.744px 0",
          }}
          id="prefix__elrw8mv7bzk8d"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M97.9 221.68s0-.3-.08-.86-.12-1.42-.22-2.51c-.18-2.21-.45-5.45-.8-9.67l.18.09a.12.12 0 01-.17 0 .12.12 0 010-.14 37.3 37.3 0 007.26-16.88 35.51 35.51 0 00.45-5.74 40.6 40.6 0 00-.53-6.12 37 37 0 00-71.05-7.44 37.65 37.65 0 00-2.39 16.87 36.53 36.53 0 004.93 15.28 37.37 37.37 0 0010 11.07 36.81 36.81 0 0012.13 5.93l1.54.4a9.92 9.92 0 001.53.33l3 .46a51.54 51.54 0 005.78.15 37.24 37.24 0 0017.46-5.39.12.12 0 01.1 0l8.09 3.09 2.11.81.72.29s-.23-.07-.69-.24l-2.09-.75-8.22-3H87a37.16 37.16 0 01-17.56 5.54 52.46 52.46 0 01-5.84-.12l-3.05-.46a10.4 10.4 0 01-1.55-.32l-1.56-.4a37.29 37.29 0 01-12.28-6 37.72 37.72 0 01-10.09-11.18 36.79 36.79 0 01-5-15.47 38 38 0 012.4-17.11 37.18 37.18 0 0110.43-14.78 17.55 17.55 0 011.75-1.41l1.82-1.35 1.92-1.17a17 17 0 012-1.08l2-1c.66-.34 1.38-.53 2.07-.81s1.38-.53 2.08-.73l2.13-.54a36.89 36.89 0 0116.94-.15 37.43 37.43 0 0128.79 30.57 41.58 41.58 0 01.52 6.19A37.47 37.47 0 0197 208.72l-.17-.16a.11.11 0 01.16 0v.07c.29 4.25.51 7.53.66 9.76.08 1.08.13 1.9.17 2.47s.08.82.08.82z"
          style={{
            transformOrigin: "67.4181px 185.77px 0",
          }}
          id="prefix__elkj9uzq73tt"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M58.1 185.82a3 3 0 11-3.05-3 3 3 0 013.05 3z"
          style={{
            transformOrigin: "55.1px 185.82px 0",
          }}
          id="prefix__el29pybhq2kkl"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M70.26 185.82a3 3 0 11-3-3 3 3 0 013 3z"
          style={{
            transformOrigin: "67.26px 185.82px 0",
          }}
          id="prefix__elm4oa57w3f1d"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M82.4 184.3a3 3 0 11-4.15-1.11 3 3 0 014.15 1.11z"
          style={{
            transformOrigin: "79.7839px 185.768px 0",
          }}
          id="prefix__el0d19v6869kqh"
          className="prefix__animable"
          fill="#263238"
        />
      </g>
      <g
        id="prefix__freepik--character-2--inject-259"
        style={{
          transformOrigin: "533.947px 320.132px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          d="M518.29 443.16c-4-14.44-18.41-65.4-22.46-79.67a5.14 5.14 0 00-4.95-3.75H385a5.15 5.15 0 00-5 6.56l25.44 89.28a5.15 5.15 0 004.95 3.74h156.82c6.15 0 7.14-8.86 1.13-10.18l-.36-.07c-9.51-2-34.9-2.13-44.73-2.12a5.14 5.14 0 01-4.96-3.79z"
          style={{
            transformOrigin: "476.086px 409.53px 0",
          }}
          id="prefix__elabokvwlj6c8"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          style={{
            transformOrigin: "451.04px 406.86px 0",
          }}
          id="prefix__el658jmqyjiw9"
          className="prefix__animable"
          fill="#455a64"
          d="M388.45 366.52l23.28 80.05 101.9.63-22.67-80.68H388.45z"
        />
        <path
          d="M431.89 395.14c0 .14-5.68.26-12.67.26s-12.67-.12-12.67-.26 5.67-.26 12.67-.26 12.67.12 12.67.26z"
          style={{
            transformOrigin: "419.22px 395.14px 0",
          }}
          id="prefix__elme1syk8qqt"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M426.45 406.76a64.85 64.85 0 01-8.29.26 64.85 64.85 0 01-8.29-.26 132.29 132.29 0 0116.58 0z"
          style={{
            transformOrigin: "418.16px 406.777px 0",
          }}
          id="prefix__eli5dz8en84k8"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M460.69 406.76c0 .15-6.73.26-15 .26s-15-.11-15-.26 6.73-.26 15-.26 15 .12 15 .26z"
          style={{
            transformOrigin: "445.69px 406.76px 0",
          }}
          id="prefix__el85kafgouomy"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M406.83 387.28a22.17 22.17 0 01-4.22-2.19l-.31-.19.27-.23.12-.11a23.64 23.64 0 013.86-3A23.09 23.09 0 01403 385l-.11.1v-.42a22.51 22.51 0 013.94 2.6z"
          style={{
            transformOrigin: "404.565px 384.42px 0",
          }}
          id="prefix__elhrrlntw5ugu"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M413 381.53a22.65 22.65 0 014.27 2.23l.28.16-.22.24-.05.06a24.27 24.27 0 01-3.5 3.43 23 23 0 013.11-3.78l.06-.06.06.4a23 23 0 01-4.01-2.68z"
          style={{
            transformOrigin: "415.275px 384.59px 0",
          }}
          id="prefix__eloi7ykddod7"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M412 379.89a28.37 28.37 0 01-1.58 5.24 27.82 27.82 0 01-2.07 5.06 30.37 30.37 0 011.58-5.24 29.62 29.62 0 012.07-5.06z"
          style={{
            transformOrigin: "410.175px 385.04px 0",
          }}
          id="prefix__elpcf7xf95ggr"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M491 394.05c0 .15-11.62.26-25.94.26s-25.94-.11-25.94-.26 11.61-.26 25.94-.26 25.94.12 25.94.26z"
          style={{
            transformOrigin: "465.06px 394.05px 0",
          }}
          id="prefix__el0m8r0ogjskzh"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M488.42 400.45c0 .15-18.13.26-40.49.26s-40.5-.11-40.5-.26 18.13-.26 40.5-.26 40.49.12 40.49.26z"
          style={{
            transformOrigin: "447.925px 400.45px 0",
          }}
          id="prefix__el9lpoiiiw0li"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M440 416.72c0 .14-5.67.26-12.67.26s-12.67-.12-12.67-.26 5.67-.26 12.67-.26 12.67.11 12.67.26z"
          style={{
            transformOrigin: "427.33px 416.72px 0",
          }}
          id="prefix__elq287raad6v"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M434.54 428.34a127.4 127.4 0 01-16.58 0 132.29 132.29 0 0116.58 0z"
          style={{
            transformOrigin: "426.25px 428.345px 0",
          }}
          id="prefix__el32wi2jttw76"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M468.78 428.34c0 .15-6.73.27-15 .27s-15-.12-15-.27 6.73-.26 15-.26 15 .12 15 .26z"
          style={{
            transformOrigin: "453.78px 428.345px 0",
          }}
          id="prefix__elyq9nikm2qqr"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M496.51 422c0 .15-18.13.26-40.49.26s-40.5-.11-40.5-.26 18.13-.26 40.5-.26 40.49.15 40.49.26z"
          style={{
            transformOrigin: "456.015px 422px 0",
          }}
          id="prefix__el5c11ha20msq"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M410.39 459.32c-.14 0-6.52-22-14.24-49.12s-13.88-49.2-13.74-49.27 6.51 21.95 14.24 49.13 13.88 49.22 13.74 49.26z"
          style={{
            transformOrigin: "396.4px 410.125px 0",
          }}
          id="prefix__eldc6atorbfa"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M438.18 386.12s8.68-2.79 14.58 0 35.66 25.74 35.66 25.74l-5 17.67-6.79-5.53s-11.16 1.55-15.5-2.79-9.31-8.37-9.31-8.37-4.47 7.14-6.88 6.72c-1.78-.3-2.82-6-2.82-6s-5.24 1.33-3.94-3.84l3.1-10.27a4.8 4.8 0 014.12-3.45l9.22-.92-5-4a42.55 42.55 0 01-9.94-.57c-1.6-.33-2.68-3.51-1.5-4.39z"
          style={{
            transformOrigin: "463.051px 407.205px 0",
          }}
          id="prefix__el1ufynwsok8wi"
          className="prefix__animable"
          fill="#ffbe9d"
        />
        <path
          d="M457.48 405.05c-.05.08-1-.52-2.74-1.19a7.83 7.83 0 00-3.09-.55 6.41 6.41 0 00-3.52 1.36 12.35 12.35 0 00-3.82 5.85 23.63 23.63 0 01-1 2.82 13.16 13.16 0 01.67-2.94 16.62 16.62 0 011.25-3 9.58 9.58 0 012.61-3.11 6.63 6.63 0 013.81-1.42 7.59 7.59 0 013.25.69 13.52 13.52 0 011.95 1 2.44 2.44 0 01.63.49z"
          style={{
            transformOrigin: "450.395px 408.105px 0",
          }}
          id="prefix__elczcobz6ewz"
          className="prefix__animable"
          fill="#eb996e"
        />
        <path
          d="M459.9 396.14a11.8 11.8 0 00-2.71-.91 12.21 12.21 0 00-2.86.25c0-.05.23-.29.75-.5a4.55 4.55 0 014.21.5c.46.33.71.62.61.66z"
          style={{
            transformOrigin: "457.126px 395.409px 0",
          }}
          id="prefix__elvx24tx4nmuf"
          className="prefix__animable"
          fill="#eb996e"
        />
        <path
          d="M506.48 298.65l-3.15.08a2.4 2.4 0 00-2 3.62 1.68 1.68 0 00.82.69c1.74.65 13.17 2.4 13.17 2.4l5.22 7.29 4-2.4s-5-13.6-4.68-13.27-13.38 1.59-13.38 1.59z"
          style={{
            transformOrigin: "512.768px 304.892px 0",
          }}
          id="prefix__eld5mug58tvet"
          className="prefix__animable"
          fill="#eb996e"
        />
        <path
          d="M546 334.76l-23.16-37.31a3.64 3.64 0 00-3-1.73l-12.66-.49a2.6 2.6 0 00-2.44 3.81 2.35 2.35 0 001.56 1.08c3.09.71 11.28 1.09 11.28 1.09l5 10.25-12.58-4.81a2.13 2.13 0 00-2.87 1.66 3.27 3.27 0 00.95 3.15c2.14 1.66 9.14 7.17 9.14 7.17s1 9.46 4.58 14.2 9.24 10.72 9.24 10.72z"
          style={{
            transformOrigin: "525.22px 319.388px 0",
          }}
          id="prefix__elkgika89z63"
          className="prefix__animable"
          fill="#ffbe9d"
        />
        <path
          d="M532.89 321.65c-.12.1-2.26-2.56-5.31-5.42s-5.81-4.86-5.72-5a8.53 8.53 0 011.91 1.17 40.46 40.46 0 017.84 7.4 7.81 7.81 0 011.28 1.85z"
          style={{
            transformOrigin: "527.374px 316.441px 0",
          }}
          id="prefix__elu6mwo0msggm"
          className="prefix__animable"
          fill="#eb996e"
        />
        <path
          d="M657.54 248.78a3.17 3.17 0 00.7-5.37c1.51-1 .78-3.53-.62-4.72s-3.27-1.81-4.42-3.25a3.76 3.76 0 004.12-3.72 3.07 3.07 0 001.33-5.81c1.69-.33 1.24-3.14-.29-3.94s-3.41-.52-5-1.08a20.3 20.3 0 00-11.4-5.12l6.42-6a4 4 0 001.25-1.64c.46-1.45-.8-2.87-2.06-3.73a16.43 16.43 0 00-9.1-2.85c-1 0-2.33.29-2.55 1.3-2.29-.79-4.79-.41-7.18 0-1.33.22-2.8.51-3.65 1.56a11.3 11.3 0 012.15-3.4 4.82 4.82 0 001.24-3.72c-.28-1.32-2-2.3-3.05-1.43 1.18-.72.8-2.7-.35-3.46a6.28 6.28 0 00-4-.55c-1 .08-2.16.37-2.32 1.32-.67-2.09-4.36-2-4.92.14a3.33 3.33 0 00-4.73.89 4.3 4.3 0 00-5.79 2.9c1-2.21 2-4.43 3-6.64.58-1.26.46-3.48-.89-3.19 2-.2 2.79-3 1.65-4.6s-3.43-2-5.35-1.56c-.47.88-1 1.76-1.43 2.64a3.9 3.9 0 00-5.45 5c-.88-.76-2.36-.13-2.88.9a5.92 5.92 0 00-.2 3.42c-2.07-1.39-5.37.85-4.83 3.29a10.94 10.94 0 00-5.75-.55 3.83 3.83 0 00-5.55-4.87 3.78 3.78 0 00-5.18-2.52c-.85-2.21-4-3.56-5.66-1.87s-.37 4.65 1 6.67l4.5 6.56-12.87-5.2a2.17 2.17 0 00-1.26-.23c-.58.14-.93.72-1.43 1-.7.45-1.61.36-2.37.69-2.07.89-1.68 4.16 0 5.7s4 2.1 5.82 3.43l-5.29 1.61a5.56 5.56 0 00-7.53-3c-1-1.91-3.66-1.87-5.77-1.55-1.9.28-4 .67-5.18 2.16-1.53 1.91-.88 4.9.79 6.7s4.05 2.69 6.36 3.53c-.19 1.66-2.24 2.38-3.9 2.32s-3.44-.52-4.93.23c-2 1-2.62 3.85-4.65 4.85a9 9 0 00-1.86.85 3.84 3.84 0 00-1 2.66c-.13 1.19-.27 2.39-.41 3.59a4.44 4.44 0 000 1.78c.59 1.87 3.3 2 5 1.06s3.11-2.53 5-3c-2.4 1.54-4.93 3.23-6.08 5.84s-.16 6.36 2.62 7 5.21-2 6.95-4.26 4.32-4.84 7.06-3.93"
          style={{
            transformOrigin: "592.533px 214.862px 0",
          }}
          id="prefix__elsoiic350soa"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M653.46 247.53c1.88-1.75 5.58-.11 5.55 2.45a7.29 7.29 0 014.08 12.21c-1.45 1.52-4.62 1.92-5.18-.11a5.68 5.68 0 01-3.62 3.91 5.48 5.48 0 01-1.36 8c3.5 1.88 3.52 7.84 0 9.75a4.48 4.48 0 11-7.73 4.52c-.52 1.75-1.1 3.59-2.49 4.77s-3.85 1.27-4.78-.29a6.15 6.15 0 01-8.31 4.62 4 4 0 01-7.63 2.22l-10.11 1.88a36.76 36.76 0 01-6.76.84 18.4 18.4 0 01-8.39-2 6.32 6.32 0 00-2.6-1 6.47 6.47 0 00-3 1.09 16.62 16.62 0 01-16.22-.62 8.5 8.5 0 00-2.37-1.23 7.51 7.51 0 00-3.05.18 30.27 30.27 0 01-7.54.39c-2.16-.16-4.51-.68-5.84-2.38s-.78-4.85 1.35-5.23a4.64 4.64 0 00-1.88-3.61 2.8 2.8 0 00-3.76.58c-.77 1.18.14 3.13 1.54 3-2 2-5.95.51-6.55-2.25s1.7-5.6 4.47-6.16A12.67 12.67 0 01550 277a4.57 4.57 0 01-6 1.89 7.9 7.9 0 01-4.3 4.58 4.71 4.71 0 01-5.66-1.78c-1-1.89.17-4.75 2.32-4.92-2-2.08-.43-6.17 2.41-6.46a6.32 6.32 0 012.48-7.33 3.32 3.32 0 01-5-.88c-.89 2.28-4.11 2.4-6.42 1.59-1.81-.63-3.63-1.68-3.63-4.2a5.06 5.06 0 011.22-3.23c1.81-2.12 4.58-2.78 7.21-3.37a32.51 32.51 0 001.12-10.66c-2.93.67-6.36-.93-7.3-3.79l13.75-10.78s33.59-9 34.82-9.12 76.62 28.86 76.62 28.86c1.84 1.54 5 .41 6-1.78s.2-4.85-1.32-6.72a19.76 19.76 0 00-5.74-4.28c2.26-.41 4.68-.88 6.19-2.73a3.66 3.66 0 00.55-4c-1-1.88-3.3-1.5-4.88-2.46a8 8 0 01-2.16-2.4"
          style={{
            transformOrigin: "595.647px 260.42px 0",
          }}
          id="prefix__elgfounxiwpzq"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M621.31 234.44a7.19 7.19 0 00-7.15-6.61l-39-5.73c-12.3 0-18.86 15.76-18.38 28.05.53 13.66 1.71 30.3 4.35 40.26 5.31 20 21.17 21 21.17 21s.72 6.7 1.57 14.09l42.44-8.81z"
          style={{
            transformOrigin: "591.533px 273.8px 0",
          }}
          id="prefix__elhtvp1h5ko0h"
          className="prefix__animable"
          fill="#ffbe9d"
        />
        <path
          d="M564.18 266.6A2.62 2.62 0 00567 269a2.5 2.5 0 002.45-2.62 2.63 2.63 0 00-2.79-2.38 2.51 2.51 0 00-2.48 2.6z"
          style={{
            transformOrigin: "566.816px 266.501px 0",
          }}
          id="prefix__el6c7gxotbivh"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M588.35 264.89a2.61 2.61 0 002.78 2.37 2.51 2.51 0 002.45-2.63 2.62 2.62 0 00-2.78-2.37 2.49 2.49 0 00-2.45 2.63z"
          style={{
            transformOrigin: "590.965px 264.76px 0",
          }}
          id="prefix__eldb7al3snt6r"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M561.67 258.42c.36.31 2.19-1.36 5-1.64s5 .92 5.28.54c.14-.17-.26-.75-1.22-1.31a7.17 7.17 0 00-4.27-.85 6.85 6.85 0 00-3.93 1.73c-.8.75-1.03 1.39-.86 1.53z"
          style={{
            transformOrigin: "566.797px 256.787px 0",
          }}
          id="prefix__eld8mfkkve47r"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M587.92 256.75c.36.31 2.19-1.35 5-1.63s5 .91 5.28.54c.14-.17-.25-.75-1.22-1.31a7.24 7.24 0 00-4.27-.86 7 7 0 00-3.93 1.73c-.78.78-1.04 1.4-.86 1.53z"
          style={{
            transformOrigin: "593.047px 255.119px 0",
          }}
          id="prefix__el4b8ik7dbd0d"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M581.27 278c0-.16-1.78-.29-4.65-.36-.72 0-1.41-.07-1.59-.55a3.66 3.66 0 01.27-2.18q.74-2.7 1.56-5.67c2.15-8.08 3.63-14.69 3.31-14.78s-2.34 6.4-4.49 14.47c-.51 2-1 3.89-1.47 5.71a4.19 4.19 0 00-.09 2.85 1.82 1.82 0 001.29.93 4.75 4.75 0 001.23 0c2.87-.09 4.64-.26 4.63-.42z"
          style={{
            transformOrigin: "577.592px 266.46px 0",
          }}
          id="prefix__el2xpc5rsod55"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M582.09 311.44a52.11 52.11 0 0026.52-10.06s-5.41 14.89-26 15.07z"
          style={{
            transformOrigin: "595.35px 308.915px 0",
          }}
          id="prefix__el72mdepvuhee"
          className="prefix__animable"
          fill="#eb996e"
        />
        <path
          d="M582.1 285.22c1.59-1.7 5.85-4.37 7.24-4.68s1.28 1.38 2.22 2.61a4.54 4.54 0 01.38 4.67c-.9 1.69-2.75 3.12-4.4 2.9s-3.18-1.9-4.54-2.88a3.29 3.29 0 01-1-1 1.46 1.46 0 010-1.47"
          style={{
            transformOrigin: "587.108px 285.623px 0",
          }}
          id="prefix__eldkc42v96ouk"
          className="prefix__animable"
          fill="#eb996e"
        />
        <path
          d="M587.93 247.72c.35.73 3.12.08 6.46.14s6.09.69 6.46 0c.16-.35-.38-1-1.53-1.65a11.28 11.28 0 00-9.84-.08c-1.16.57-1.71 1.24-1.55 1.59z"
          style={{
            transformOrigin: "594.39px 246.61px 0",
          }}
          id="prefix__el2d4ozqs7aon"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M561.88 250.18c.56.59 2.42-.27 4.75-.54s4.34 0 4.72-.72c.17-.35-.21-.95-1.13-1.47a6.66 6.66 0 00-4-.65 6.55 6.55 0 00-3.66 1.67c-.73.74-.93 1.42-.68 1.71z"
          style={{
            transformOrigin: "566.583px 248.555px 0",
          }}
          id="prefix__elhzikvs9pna"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M624.06 255.28a3.42 3.42 0 01-.55 4 2.35 2.35 0 01-3.43-.56c-.76 1.3-2.93.31-2.82-1.28-1 .73-2.64-.59-2.44-2-1.22.64-2.21-1.34-3-2.65a22.92 22.92 0 00-1.54-2 14.31 14.31 0 01-3-7.44c-1.87-1.71-2.62-4.58-3.25-7.24-.4-1.67-.79-3.33-1.19-5-.36-.36-.72-.71-1.07-1.07a2.77 2.77 0 01-1.53 2.83 6 6 0 01-3.08.3l-3.09-.25-1.82.76c.73 1.51.37 3.36 0 5-.26 1.13-.58 2.37-1.44 3a1.44 1.44 0 01-2.16-1.31 1.59 1.59 0 01-2.5-.11 5.22 5.22 0 01-1-3 13.37 13.37 0 011.59-7.61L582 235.1a2.48 2.48 0 01-1.2.93 1.41 1.41 0 01-1.31 1.71 3.63 3.63 0 01-2.09-1.1c-1.44-1.2-3-3.34-2.08-5a1.15 1.15 0 01-.7-1.61l-5.45 5.22c.56-.42 1.32.43 1.28 1.22a3.23 3.23 0 01-1 1.91 4.66 4.66 0 011 2.75c1-1.09 2.78.52 2.61 2.1a3.39 3.39 0 01-2.88 2.82 2.36 2.36 0 01-2.85-1.44c-1.28.43-2.75-1.23-2.45-2.76-.87.74-1.89-.87-2.09-2.15a18.55 18.55 0 01.25-7.05c.08.33-.26.65-.52.49a.51.51 0 010-.8q-1.23 4.29-2.44 8.58a19.14 19.14 0 00-1.07 7c.09 1 .13 2.33-.68 2.51a1.21 1.21 0 01-.67-.09 12.34 12.34 0 01-6.09-5.65 9.37 9.37 0 01-1.14-2.79c-.43-2.08.22-4.2.13-6.32a20.34 20.34 0 01-.13-2.8 8.35 8.35 0 011.75-3.87c2.79-4.09 5.76-8.32 9.89-10.3 2.53-1.22 5.35-1.5 7.88-2.69a47.09 47.09 0 004.5-2.71c6.16-3.78 13.3-5 20.34-5.16a33.3 33.3 0 0111.75 1.41c4.2 1.44 8 4.15 11.67 7.06 5.45 4.35 10.67 9.3 14.53 15.59 3 4.83 5.1 10.61 4.89 16.46s-3.18 11.64-7.86 13.36l-2.14-2"
          style={{
            transformOrigin: "593.963px 234.961px 0",
          }}
          id="prefix__elo1ndh8ev7ra"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M618.92 259.79c.26-.16 10.93-4.87 12.06 6.49s-10.5 10.16-10.56 9.84-1.5-16.33-1.5-16.33z"
          style={{
            transformOrigin: "624.989px 267.502px 0",
          }}
          id="prefix__el455gn20oymi"
          className="prefix__animable"
          fill="#ffbe9d"
        />
        <path
          d="M623.46 271.47c0-.05.22.11.57.23a2 2 0 001.48-.11c1.16-.56 2-2.57 1.83-4.62a6.57 6.57 0 00-.84-2.78 2.28 2.28 0 00-1.64-1.37 1 1 0 00-1.12.66c-.12.33 0 .55-.08.57s-.26-.16-.22-.64a1.3 1.3 0 01.38-.76 1.51 1.51 0 011.06-.4 2.8 2.8 0 012.25 1.56 6.69 6.69 0 011 3.1c.16 2.29-.8 4.55-2.4 5.19a2.1 2.1 0 01-1.84-.12c-.38-.24-.46-.49-.43-.51z"
          style={{
            transformOrigin: "625.791px 267.253px 0",
          }}
          id="prefix__ela9erkuxx6wo"
          className="prefix__animable"
          fill="#eb996e"
        />
        <path
          d="M575.91 228a3 3 0 01-.92-1.38 2 2 0 01.33-1.77 2.14 2.14 0 012.11-.79l.49.11-.26-.44a2.25 2.25 0 01.33-2.58 2.2 2.2 0 012.83-.21l.33-.39a.91.91 0 01-.18-.27 1.3 1.3 0 01.06-1.09 1.47 1.47 0 01.86-.68 2.33 2.33 0 011.14-.07 3.15 3.15 0 001.31.14c.53-.16.73-.59 1-.8a4.44 4.44 0 01.82-.64 5.19 5.19 0 011.78-.62 5 5 0 012.72.35c.6.27.89.51.92.47a2.32 2.32 0 00-.84-.65 4.86 4.86 0 00-2.84-.53 5.24 5.24 0 00-2 .61 4.26 4.26 0 00-.92.69c-.31.27-.52.61-.79.66a3.07 3.07 0 01-1.1-.17 2.87 2.87 0 00-1.39.08 1.93 1.93 0 00-1.15.92 1.79 1.79 0 00-.08 1.55 1.29 1.29 0 00.3.42l.33-.39a2.62 2.62 0 00-3.85 3.42l.24-.32a2.51 2.51 0 00-2.49 1 2.27 2.27 0 00-.28 2 2.2 2.2 0 00.75 1.09.94.94 0 00.44.28z"
          style={{
            transformOrigin: "583.092px 222.063px 0",
          }}
          id="prefix__el0daqvlknbowq"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M563.59 232.68a3.55 3.55 0 01-1.12-1.32 2.57 2.57 0 01-.09-1.93 2.64 2.64 0 011.84-1.67l.36-.09-.28-.25a3.18 3.18 0 01-1.17-2.68 1.71 1.71 0 01.89-1.26 1.37 1.37 0 011.53 0l1.61 1.38-1.25-1.72a2.64 2.64 0 01-.39-2.2 2.45 2.45 0 011.59-1.69 2.6 2.6 0 011.72 0l.63.22-.31-.59c-.45-.83.33-1.94 1.2-2.15a4.36 4.36 0 012.77.37l.51.21-.21-.51a1.89 1.89 0 01.42-1.88 3.43 3.43 0 011.65-1 8.74 8.74 0 013.27-.28 14.91 14.91 0 012.85.68 2.31 2.31 0 00-.69-.37 8.62 8.62 0 00-2.12-.59 8.84 8.84 0 00-3.41.18 3.89 3.89 0 00-1.88 1.06 2.32 2.32 0 00-.51 2.4l.31-.31a4.82 4.82 0 00-3.08-.42 2.36 2.36 0 00-1.39 1 1.83 1.83 0 00-.14 1.83l.32-.36a3.07 3.07 0 00-2.07 0 3 3 0 00-1.91 2 3.12 3.12 0 00.48 2.63l.36-.34a1.83 1.83 0 00-2.08-.07 2.14 2.14 0 00-1.11 1.61 3.58 3.58 0 001.36 3l.08-.34a3 3 0 00-2 2 2.78 2.78 0 00.19 2.13 2.74 2.74 0 00.9 1 1.08 1.08 0 00.37.32z"
          style={{
            transformOrigin: "571.806px 222.976px 0",
          }}
          id="prefix__elptot34y8c7"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M536.51 238a2 2 0 01.51-1.47 2.43 2.43 0 011.63-.79 7.35 7.35 0 012.48.3l.3.08-.07-.3a2.21 2.21 0 011.55-2.34 6.52 6.52 0 013.68.19l1.65.42-1.47-.86a1.83 1.83 0 01-.15-2.62 4.09 4.09 0 013.09-1.09h1.17l-.9-.48a2 2 0 01-.12-3.09 3 3 0 013.3 0l1.14.72-.82-1.06a4.43 4.43 0 01-.48-4.47 4.12 4.12 0 012.8-2.25 4.61 4.61 0 012.44 0c.55.16.82.33.84.3a.86.86 0 00-.19-.15 3.63 3.63 0 00-.6-.3 4.55 4.55 0 00-2.55-.18 4.39 4.39 0 00-3.1 2.36 4.81 4.81 0 00.46 4.93l.32-.35a3.42 3.42 0 00-3.87 0 2.46 2.46 0 00-.9 2 2.18 2.18 0 001.1 2l.11-.48h-.16a4.53 4.53 0 00-3.47 1.29 2.6 2.6 0 00-.58 1.76 1.87 1.87 0 00.87 1.59l.18-.44a6.67 6.67 0 00-4-.12 2.58 2.58 0 00-1.75 2.83l.22-.23a7.55 7.55 0 00-2.61-.24 2.66 2.66 0 00-1.75 1 1.82 1.82 0 00-.44 1.17.85.85 0 00.14.37z"
          style={{
            transformOrigin: "547.725px 228.228px 0",
          }}
          id="prefix__el5ojm8btzqwl"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M548 210.44a1.58 1.58 0 00.7.17 8.92 8.92 0 002-.12 5.91 5.91 0 012.9.12 1.83 1.83 0 011.14 1.13 1.33 1.33 0 01-.36 1.56l.38.21c0-.67.8-1.17 1.48-1.69a8.61 8.61 0 012.29-1.29 3.07 3.07 0 012.47.11 2.07 2.07 0 011.26 1.77v.64l.43-.47a5.65 5.65 0 013.19-1.74 6.42 6.42 0 012.9.1 8.24 8.24 0 012.35 1.16 2.43 2.43 0 00-.5-.51 5.54 5.54 0 00-1.77-.94 6.52 6.52 0 00-3.06-.21 6 6 0 00-3.47 1.81l.42.17a2.53 2.53 0 00-1.51-2.23 3.62 3.62 0 00-2.87-.15 8.9 8.9 0 00-2.42 1.37 11.47 11.47 0 00-1 .84 1.88 1.88 0 00-.64 1.24v.51l.39-.28a1.78 1.78 0 00.51-2.11 2.23 2.23 0 00-1.41-1.36 5.92 5.92 0 00-3.1 0 11.33 11.33 0 01-1.94.25 5.5 5.5 0 00-.76-.06z"
          style={{
            transformOrigin: "559.565px 211.907px 0",
          }}
          id="prefix__ell39cgvryq9"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M572.29 197.85a5.21 5.21 0 011.37 0 3.4 3.4 0 011.37.67 2.9 2.9 0 011 1.63l.05.28.26-.12a1.69 1.69 0 012 .84 5.24 5.24 0 01.41 2.82l-.05 1 .54-.89.08-.14a2.17 2.17 0 011.68-.92 2.45 2.45 0 011.75.54 3.87 3.87 0 011.36 2.91 7.25 7.25 0 01-.33 2.28 4.31 4.31 0 00-.23.83s.2-.25.42-.77a6.25 6.25 0 00.5-2.34 4.18 4.18 0 00-1.42-3.28 2.87 2.87 0 00-4.17.47l-.1.18.48.13a5.46 5.46 0 00-.5-3.09 2.14 2.14 0 00-2.59-1l.31.16a3.15 3.15 0 00-1.22-1.83 3.32 3.32 0 00-1.54-.64 2.83 2.83 0 00-1.06.05c-.26.15-.37.21-.37.23z"
          style={{
            transformOrigin: "578.381px 203.561px 0",
          }}
          id="prefix__el5ev8wd1e4xf"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M596.35 211a1.44 1.44 0 00.66-.23 4.21 4.21 0 001.42-1.26 4.51 4.51 0 00.89-2.7 2.37 2.37 0 01.19-1.43c.25-.39.85-.68 1.17-1.32a2.57 2.57 0 00-1-3.38l.07.37a8.3 8.3 0 001.85-3.28 3.48 3.48 0 00.21-1.44c-.06 0-.16.52-.48 1.35a9.16 9.16 0 01-1.93 3.05l-.22.22.29.15a2.13 2.13 0 01.79 2.72c-.21.47-.75.73-1.13 1.28a2.68 2.68 0 00-.24 1.73 4.42 4.42 0 01-.72 2.47 6.64 6.64 0 01-1.82 1.7z"
          style={{
            transformOrigin: "599.084px 203.665px 0",
          }}
          id="prefix__elvkkj5cxsfjq"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M603.43 214.73h.44a5.77 5.77 0 001.2-.23 7 7 0 003.55-2.56h-.33a4.44 4.44 0 003.18 1.26 4.58 4.58 0 001.89-.44 2.84 2.84 0 001.49-1.45 5.78 5.78 0 00.12-.76 1 1 0 01.27-.51 3.09 3.09 0 011.12-.65 4.1 4.1 0 001.26-.69 1.45 1.45 0 00.59-1.34l-.3.26a4.53 4.53 0 003.14-.27 4.86 4.86 0 001.91-1.51 4 4 0 00.7-1.41 1.44 1.44 0 00.07-.55 6.61 6.61 0 01-1 1.79 4.91 4.91 0 01-1.85 1.33 4.2 4.2 0 01-2.84.17l-.36-.1.06.37a1 1 0 01-.44.89 4 4 0 01-1.13.59 3.46 3.46 0 00-1.32.77 1.55 1.55 0 00-.4.76 4.7 4.7 0 01-.11.7 2.33 2.33 0 01-1.22 1.15 4 4 0 01-1.67.4 4.05 4.05 0 01-2.87-1.07l-.18-.18-.15.21a7 7 0 01-3.27 2.57c-.98.4-1.56.44-1.55.5z"
          style={{
            transformOrigin: "613.582px 209.305px 0",
          }}
          id="prefix__elguvfy23rm9p"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M645.6 226.07v-.18a2.6 2.6 0 000-.54 5.32 5.32 0 00-.47-2 12.32 12.32 0 00-1.69-2.73 11.6 11.6 0 00-1.31-1.5 3.36 3.36 0 00-1-.59 1.39 1.39 0 00-1.26.14l.35.18a3.43 3.43 0 00-5.88-2.36l.43.16a2.34 2.34 0 00-1.16-1.82 2.23 2.23 0 00-2.21 0 2.36 2.36 0 00-.93.87l.48.12a1.44 1.44 0 00-.67-1.14 2 2 0 00-1.21-.36 4.71 4.71 0 00-2.13.8l.33.07a3.65 3.65 0 00-2.39-1.31 5.13 5.13 0 00-2.51.27 13 13 0 00-3.66 2.35l.3.2a.93.93 0 00-.2-.88 1.55 1.55 0 00-.69-.41 2.65 2.65 0 00-1.39-.06 7.65 7.65 0 00-2 .84 6.75 6.75 0 00-1.08.81c-.23.21-.33.33-.32.35s.49-.43 1.5-1a7.81 7.81 0 011.94-.73 2.31 2.31 0 011.21.09c.41.13.79.46.64.86l-.22.6.52-.4a12.72 12.72 0 013.57-2.21 4.74 4.74 0 012.29-.23 3.2 3.2 0 012.06 1.14l.13.17.19-.11a4.28 4.28 0 011.9-.72c.61 0 1.34.42 1.35 1v.91l.46-.79a1.79 1.79 0 01.72-.67 1.74 1.74 0 011.71 0 1.89 1.89 0 01.92 1.42v.55l.39-.4a3 3 0 015.08 2v.43l.34-.25c.51-.39 1.22 0 1.71.4a11.27 11.27 0 011.29 1.41 12.53 12.53 0 011.74 2.61 6.82 6.82 0 01.83 2.64z"
          style={{
            transformOrigin: "629.472px 219.949px 0",
          }}
          id="prefix__elndb7w82aq3r"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M644.38 241.4a2 2 0 00.22-.36 9.72 9.72 0 00.49-1.09 3.71 3.71 0 00.2-1.92 2.76 2.76 0 00-.51-1.14 2 2 0 00-1.22-.73l.13.26a2.41 2.41 0 00-3-3.39l.27.33a1.93 1.93 0 00-.32-2.27 2.87 2.87 0 00-2.3-.78 9 9 0 01-1.15.12 1 1 0 01-.77-.53 4.21 4.21 0 00-.79-1 2.18 2.18 0 00-1.28-.53 12.61 12.61 0 00-2.74.23 3 3 0 01-2.28-.4c-.28-.23-.5-.58-.81-.9a2.63 2.63 0 00-1.12-.69 2.75 2.75 0 00-2.39.39l.34.29a2.05 2.05 0 00-.54-2.33 2.89 2.89 0 00-2-.74 9.1 9.1 0 00-3.31.78 11 11 0 00-1.92 1c-.42.28-.62.46-.6.48a23.86 23.86 0 012.62-1.25 9.1 9.1 0 013.2-.66 2.52 2.52 0 011.74.66A1.64 1.64 0 01625 227l-.46.86.79-.58a2.28 2.28 0 012-.29 2.11 2.11 0 01.91.56 9.72 9.72 0 00.84.95 2.7 2.7 0 001.29.55 5.69 5.69 0 001.37 0 13.21 13.21 0 012.62-.23 1.76 1.76 0 011 .41 3.75 3.75 0 01.69.94 1.53 1.53 0 001.17.75 9.16 9.16 0 001.21-.13 2.4 2.4 0 011.91.61 1.47 1.47 0 01.29 1.7l-.35.57.63-.23a2 2 0 012.28.66 2.09 2.09 0 01.19 2.13l-.12.23h.26a2 2 0 011.5 1.57 3.64 3.64 0 01-.11 1.8c-.32 1.03-.58 1.55-.53 1.57z"
          style={{
            transformOrigin: "631.158px 232.81px 0",
          }}
          id="prefix__elhtkqhpuda6e"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M646.91 272.7s.19 0 .48-.21a3.68 3.68 0 001.07-1.05 3.75 3.75 0 00.63-2.27 3.94 3.94 0 00-1.37-2.75v.27a7.09 7.09 0 001.06-2.69 2.94 2.94 0 00-.3-1.63 2.13 2.13 0 00-1.35-1.14l.1.45a3 3 0 001-2.81 3.39 3.39 0 00-.71-1.62 2.82 2.82 0 00-1.45-.91c-.51-.17-.76-.37-.83-.87a3.86 3.86 0 00-.51-1.46 5.28 5.28 0 00-2.13-1.84c-.75-.42-1.43-.82-2.08-1.17a8.77 8.77 0 00-3.29-1.13 4.55 4.55 0 00-1 0c-.21 0-.32.07-.32.09s.46 0 1.25.08a9.4 9.4 0 013.14 1.25l2 1.22a4.85 4.85 0 011.94 1.71 3.74 3.74 0 01.44 1.32 1.49 1.49 0 00.37.81 2 2 0 00.78.43 2.67 2.67 0 011 4.47l-.41.32.51.13a2 2 0 011.29 2.22 6.89 6.89 0 01-1 2.54l-.09.16.14.11a3.59 3.59 0 011.29 2.44 3.49 3.49 0 01-.49 2.1 5.12 5.12 0 01-1.16 1.43z"
          style={{
            transformOrigin: "642.502px 261.271px 0",
          }}
          id="prefix__el6mtbwnj6pky"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M629.41 261.11a1.88 1.88 0 00.69-.22 6.63 6.63 0 001.7-1.13 6.89 6.89 0 001.78-2.62 2.75 2.75 0 00.13-2 1.36 1.36 0 00-.88-.79 1.07 1.07 0 00-1.22.35l.41.19a3.49 3.49 0 00.13-2 1.64 1.64 0 00-.72-.89 1.32 1.32 0 00-1.19 0c-.34.11-.68.27-.87.21s-.26-.27-.28-.65a3.18 3.18 0 00-1.11-2.08 3.37 3.37 0 00-3.59-.61l.36.26a2.91 2.91 0 00-.84-2.77 1.74 1.74 0 00-1.44-.28 1.32 1.32 0 00-1.05 1h.45a6.93 6.93 0 00-1.29-3.64 7.33 7.33 0 00-2.16-2.05 6.59 6.59 0 00-1.75-.75 2.15 2.15 0 00-.67-.1 10.91 10.91 0 012.28 1.07 7.43 7.43 0 012 2 6.81 6.81 0 011.14 3.46l.08 1.87.36-1.83c.13-.63 1.19-.84 1.76-.39a2.45 2.45 0 01.63 2.31l-.07.47.43-.21a2.93 2.93 0 013 .55 2.66 2.66 0 01.94 1.74 1.83 1.83 0 00.11.6.79.79 0 00.55.5 2.23 2.23 0 001.16-.24.84.84 0 01.79 0 1.15 1.15 0 01.5.62 3.07 3.07 0 01-.12 1.74l-.34 1.3.8-1.1c.3-.44 1.18-.17 1.34.34a2.39 2.39 0 01-.1 1.72 6.86 6.86 0 01-1.61 2.55 9.83 9.83 0 01-2.22 1.5z"
          style={{
            transformOrigin: "624.92px 250.825px 0",
          }}
          id="prefix__el3xolds228uo"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M600.27 232.29a3.85 3.85 0 001.46-.77 4.32 4.32 0 001.24-1.35 2.82 2.82 0 00.26-2.28 1.78 1.78 0 00-.27-.51l-.07.36a2.45 2.45 0 001.08-1.83 2.25 2.25 0 00-.51-1.63c-.65-.76-1.32-.77-1.31-.72s.55.22 1 .93a2 2 0 01.33 1.37 2.1 2.1 0 01-.9 1.45l-.21.14.14.22a1.44 1.44 0 01.2.39 2.47 2.47 0 01-.19 1.89 4.56 4.56 0 01-1 1.28c-.77.64-1.29.99-1.25 1.06z"
          style={{
            transformOrigin: "602.123px 227.916px 0",
          }}
          id="prefix__el245kgai4gy"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M587.74 228.07a3.11 3.11 0 01-.56-1.84 2.13 2.13 0 011-1.74 2.3 2.3 0 012.49.12l.35.26v-.44a4.47 4.47 0 01.42-1.58 1.94 1.94 0 011.18-1c.81-.2 1.81.46 1.66 1.16h.5a3.86 3.86 0 013.23-3.8 5.89 5.89 0 012.19.16s-.17-.15-.54-.29a3.91 3.91 0 00-1.7-.18 4.08 4.08 0 00-2.36 1.09 4.31 4.31 0 00-1.32 3l.49.05a1.48 1.48 0 00-.67-1.44 2.09 2.09 0 00-1.59-.32 2.42 2.42 0 00-1.52 1.33 4.5 4.5 0 00-.45 1.77l.39-.17a2.75 2.75 0 00-3-.08 2.53 2.53 0 00-.65 3.55c.28.32.45.4.46.39z"
          style={{
            transformOrigin: "593.509px 223.473px 0",
          }}
          id="prefix__eltiwdewhisg9"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M586.85 290.78a2.12 2.12 0 00.92 0 6.53 6.53 0 002.34-.91 6.4 6.4 0 001.35-1.11 4.35 4.35 0 001-1.77 6.15 6.15 0 00-1-4.45 7.58 7.58 0 00-2-2.17l-.1-.06h-.1a24.62 24.62 0 00-5.34 3.21c-.61.48-1.07.88-1.38 1.18a2 2 0 00-.44.49s.73-.57 2-1.45a28.28 28.28 0 015.33-3h-.19a7.24 7.24 0 011.91 2.05 5.86 5.86 0 011 4.13 5.09 5.09 0 01-2.15 2.71 7.12 7.12 0 01-2.21 1c-.62.11-.94.11-.94.15z"
          style={{
            transformOrigin: "587.319px 285.57px 0",
          }}
          id="prefix__elge2y93qrpyu"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M520.86 342.56s23.88 53.6 27.22 56.2c.68.53 4.58 5.16 10.37 5.3 22.85.56 75.11 4.89 75.11 4.89l7.3-30.27-62.76-4.5-31.6-42.95z"
          style={{
            transformOrigin: "580.86px 370.09px 0",
          }}
          id="prefix__elurcfztmzlb"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M592.69 382.41s-34.52 54.47-37.8 58.61c-7.24 9.12-16.9 13.91-30.49 10.2s-49.79-23.42-49.79-23.42l10.83-24.63 42.34 9 32.74-65.62a30.4 30.4 0 0116.91-15.74c5.12-1.87 11.34-4.28 18.14-1.66z"
          style={{
            transformOrigin: "535.09px 390.24px 0",
          }}
          id="prefix__elugnhwyzhh99"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M585.21 326.41l40.19-7c7.15-1.25 27.91 10.35 32.51 21.1l30.18 116.68H589.6l-4.54-33s-13.72-15.31-16.27-18.48 16.42-79.3 16.42-79.3z"
          style={{
            transformOrigin: "628.322px 388.254px 0",
          }}
          id="prefix__el9hlvaawsz8"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M583.77 329.17l-1.55-10.05a3.3 3.3 0 012.75-3.77l41.46-6.56a3.3 3.3 0 013.79 2.79l1.71 11.77z"
          style={{
            transformOrigin: "607.055px 318.959px 0",
          }}
          id="prefix__elvubkmh3h4g8"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M583.79 328.53a3.33 3.33 0 01-.62.27l-1.81.72-6.88 2.61a31.71 31.71 0 00-6.5 4.65 33.35 33.35 0 00-6 7.76c-1.79 3.08-3.47 6.52-5.28 10.09s-3.65 7.35-5.58 11.22l-16.32 32.86c-2.12 4.19-3.84 7.58-5.06 9.9-.61 1.17-1.09 2.07-1.43 2.67l-.38.69c-.09.15-.14.23-.15.22a1.23 1.23 0 01.1-.25l.34-.71 1.34-2.71 4.91-10c4.15-8.46 9.87-20.08 16.19-32.93l5.59-11.21c1.82-3.58 3.51-7 5.33-10.11a33.75 33.75 0 016.15-7.81 31.6 31.6 0 016.63-4.63l6.92-2.48 1.84-.63a5.21 5.21 0 01.67-.19z"
          style={{
            transformOrigin: "555.785px 370.36px 0",
          }}
          id="prefix__el684lkznkmqq"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M598.61 374.6s-.07.16-.25.44l-.81 1.18c-.76 1.09-1.78 2.55-3 4.33-2.55 3.66-6 8.74-9.73 14.42s-7 10.88-9.4 14.65c-1.16 1.82-2.11 3.33-2.82 4.45-.32.48-.58.87-.79 1.2a2 2 0 01-.3.4 1.72 1.72 0 01.21-.46l.7-1.25c.62-1.08 1.54-2.63 2.69-4.54 2.3-3.81 5.55-9.05 9.28-14.73s7.23-10.75 9.86-14.35a143.5 143.5 0 013.15-4.24l.88-1.12a2.13 2.13 0 01.33-.38z"
          style={{
            transformOrigin: "585.06px 395.135px 0",
          }}
          id="prefix__elceltd6eo8tf"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M631.74 320.49s-.13.12-.42.29l-1.24.74c-.54.32-1.21.7-2 1.1s-1.69.88-2.73 1.32-2.15 1-3.4 1.43-2.57.94-4 1.42a73.09 73.09 0 01-9.42 2.28 74.91 74.91 0 01-9.65.92h-4.23c-1.32 0-2.56-.14-3.68-.25s-2.13-.24-3-.36-1.64-.25-2.26-.38l-1.42-.29a1.43 1.43 0 01-.48-.14 2.69 2.69 0 01.5 0l1.44.19c.61.1 1.37.21 2.26.29s1.89.23 3 .29 2.34.16 3.66.18 2.72 0 4.2 0a79.71 79.71 0 009.58-.95 77.61 77.61 0 009.36-2.23c1.41-.46 2.76-.87 4-1.36s2.37-.92 3.4-1.36 1.94-.88 2.75-1.26 1.5-.71 2.05-1l1.29-.65a2.75 2.75 0 01.44-.22z"
          style={{
            transformOrigin: "607.775px 325.24px 0",
          }}
          id="prefix__eliq6fkkmy4b"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M578 403.83a10.09 10.09 0 01-1.4-.81l-3.72-2.34-12.28-7.74c-4.8-3-9.12-5.81-12.21-7.88-1.54-1-2.79-1.88-3.64-2.48a9.53 9.53 0 01-1.28-1 10.09 10.09 0 011.4.81l3.72 2.34 12.29 7.75c4.79 3 9.11 5.8 12.2 7.87 1.54 1 2.79 1.88 3.64 2.48a9.53 9.53 0 011.28 1z"
          style={{
            transformOrigin: "560.735px 392.705px 0",
          }}
          id="prefix__elfes8ogc1lbs"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M585.05 393a11.68 11.68 0 01-1.47-.77c-.94-.52-2.27-1.31-3.91-2.3-3.28-2-7.73-4.83-12.65-8s-9.43-5.89-12.75-7.78c-1.66-.95-3-1.71-3.94-2.23a10.2 10.2 0 01-1.43-.85 10.28 10.28 0 011.52.67c1 .46 2.35 1.18 4 2.09 3.37 1.81 7.92 4.52 12.85 7.66l12.56 8.1 3.82 2.43a9.87 9.87 0 011.4.98z"
          style={{
            transformOrigin: "566.975px 382.035px 0",
          }}
          id="prefix__eldqts4cmxqyi"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M675.14 407.13l-.25.06-.74.12-2.85.41c-2.48.35-6.07.79-10.51 1.29-8.89 1-21.19 2.11-34.8 3s-26 1.56-34.87 2l-10.57.54-2.88.13h-1 .25l.75-.07 2.87-.23 10.56-.71 34.9-2.15c13.6-.92 25.9-2 34.79-2.87 4.44-.45 8-.84 10.52-1.13l2.86-.31.75-.07a1.29 1.29 0 01.22-.01z"
          style={{
            transformOrigin: "625.905px 410.904px 0",
          }}
          id="prefix__eljfz4gv4ej28"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M670.55 389.42a5.57 5.57 0 01-.88.1l-2.55.19-9.37.64c-7.92.54-18.85 1.36-30.91 2.4s-23 2.1-30.86 2.89l-9.35.92-2.55.23a7.36 7.36 0 01-.89 0 5.29 5.29 0 01.88-.15l2.54-.33 9.33-1.09c7.89-.88 18.79-2 30.86-3s23-1.8 30.92-2.25c4-.23 7.17-.39 9.39-.47l2.55-.09a5 5 0 01.89.01z"
          style={{
            transformOrigin: "626.87px 393.099px 0",
          }}
          id="prefix__el9aq7cbdz3p"
          className="prefix__animable"
          fill="#fff"
        />
        <g
          style={{
            transformOrigin: "583.645px 396.8px 0",
          }}
          className="prefix__animable"
          opacity={0.3}
          id="prefix__el8r1ca8y91ew"
        >
          <path
            d="M574.05 411.8a40.59 40.59 0 0019.19-30z"
            id="prefix__elaydrum99pkc"
            style={{
              transformOrigin: "583.645px 396.8px 0",
            }}
            className="prefix__animable"
          />
        </g>
      </g>
      <g
        id="prefix__freepik--character-1--inject-259"
        style={{
          transformOrigin: "196.379px 311.244px 0",
          animation: "1.5s Infinite linear floating",
          animationDelay: "0s",
        }}
        className="prefix__animable"
      >
        <path
          d="M97.13 250.28l27.42 139.2a14.39 14.39 0 0017.24 11.26L316.17 362a14.38 14.38 0 0011-16.71L301.9 211.43A14.38 14.38 0 00285.1 200l-176.54 33.4a14.38 14.38 0 00-11.43 16.88z"
          style={{
            transformOrigin: "212.144px 300.415px 0",
          }}
          id="prefix__el4i90y84ikv6"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M97.13 250.28s0-.15-.09-.46a11.55 11.55 0 01-.17-1.4 13.66 13.66 0 01.67-5.44 15.27 15.27 0 011.78-3.65 14.5 14.5 0 013.42-3.51 14.3 14.3 0 015.18-2.39c2-.45 4.13-.81 6.38-1.25l76.5-14.56 52.84-10 29.43-5.62 7.64-1.45 3.87-.73c.63-.13 1.31-.2 2-.29a16.85 16.85 0 012 0 14.58 14.58 0 017.59 2.61 14.48 14.48 0 015.1 6.32 18.66 18.66 0 011.09 4c.25 1.35.51 2.69.76 4 .51 2.71 1 5.42 1.54 8.16q1.56 8.2 3.14 16.59 3.2 16.79 6.45 34.22t6.7 35.45l3.42 18.12q.87 4.56 1.73 9.16l.87 4.6a29.69 29.69 0 01.7 4.67 14.45 14.45 0 01-2.7 9 14.61 14.61 0 01-7.53 5.49c-1.53.45-3 .71-4.54 1.07l-4.51 1-9 2-35.22 7.82-66.6 14.78-31 6.89-14.85 3.29-7.26 1.61c-1.21.25-2.37.57-3.61.75a14.51 14.51 0 01-15.14-7.71 12.24 12.24 0 01-.71-1.62l-.3-.83-.21-.85c-.29-1.14-.46-2.27-.7-3.39-.44-2.24-.88-4.47-1.31-6.67q-2.59-13.2-5-25.32c-6.32-32.26-11.44-58.37-15-76.42-1.76-9-3.12-16-4-20.78-.45-2.37-.8-4.18-1-5.4s-.33-1.85-.33-1.85.14.62.38 1.84.62 3 1.09 5.39c1 4.76 2.35 11.75 4.15 20.77 3.57 18 8.74 44.13 15.13 76.38q2.39 12.09 5 25.31c.43 2.2.87 4.43 1.31 6.67a23 23 0 001.89 6.58 14.09 14.09 0 0014.71 7.47c1.18-.17 2.38-.5 3.57-.75l7.26-1.61 14.84-3.34 31-6.9 66.59-14.82 35.22-7.83 9-2 4.51-1c1.49-.35 3-.62 4.49-1.06a14.12 14.12 0 009.87-14 30.62 30.62 0 00-.69-4.6l-.87-4.6c-.58-3.06-1.15-6.11-1.73-9.16q-1.73-9.03-3.43-18.03-3.4-18-6.69-35.44t-6.46-34.22q-1.57-8.38-3.13-16.59l-1.53-8.16c-.26-1.35-.51-2.69-.77-4a18.15 18.15 0 00-1.05-3.89 15.79 15.79 0 00-2-3.42 15 15 0 00-2.89-2.69 14.18 14.18 0 00-7.34-2.53 18.12 18.12 0 00-2 0c-.64.1-1.28.15-1.93.29l-3.86.73-7.64 1.44-29.43 5.48-52.85 10-76.53 14.4c-2.25.44-4.4.79-6.38 1.23a14.22 14.22 0 00-5.13 2.33 14.45 14.45 0 00-3.4 3.47 15.71 15.71 0 00-1.8 3.6 14.07 14.07 0 00-.71 5.41c0 .62.13 1.08.15 1.39z"
          style={{
            transformOrigin: "212.254px 300.402px 0",
          }}
          id="prefix__elpqed2zu6uco"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M104 253.75l25.69 130.37a13.46 13.46 0 0016.13 10.54l165.73-36.58a13.47 13.47 0 0010.31-15.65l-23.64-125.35a13.48 13.48 0 00-15.74-10.74l-167.74 31.57A13.46 13.46 0 00104 253.75z"
          style={{
            transformOrigin: "212.921px 300.543px 0",
          }}
          id="prefix__elo33xljrq4y"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M104 253.75s0-.15-.08-.44a10.54 10.54 0 01-.16-1.31 12.58 12.58 0 01.63-5.14 13.51 13.51 0 015-6.72 13.34 13.34 0 014.9-2.21c1.89-.41 3.9-.76 6-1.17l72.17-13.67 49.84-9.41 27.77-5.24 7.21-1.36 3.64-.68a20.81 20.81 0 013.73-.51 15.25 15.25 0 011.91.07 17.17 17.17 0 011.87.37 12.66 12.66 0 013.54 1.48 13.67 13.67 0 015.24 5.6 14.55 14.55 0 011.25 3.7l.72 3.81c.48 2.55 1 5.12 1.46 7.69q1.46 7.74 3 15.65 3 15.81 6.1 32.27T316 310q1.59 8.49 3.23 17.11l1.63 8.63c.27 1.45.54 2.89.82 4.34a30.23 30.23 0 01.65 4.41 13.7 13.7 0 01-9.71 13.6c-5.72 1.38-11.37 2.54-17 3.81l-33.24 7.33-62.83 13.86-29.26 6.45-14 3.08-6.84 1.51-3.38.75c-.57.1-1.15.21-1.72.28a14.53 14.53 0 01-1.74.06 13.73 13.73 0 01-12.73-9.54c-.31-1.07-.51-2.14-.71-3.2-.42-2.12-.83-4.21-1.24-6.29q-2.44-12.45-4.69-23.88c-6-30.43-10.78-55-14.12-72.08-1.65-8.51-2.94-15.11-3.81-19.6q-.64-3.36-1-5.1c-.21-1.15-.31-1.74-.31-1.74s.13.58.36 1.73.58 2.86 1 5.09c.9 4.48 2.22 11.08 3.91 19.58 3.38 17 8.25 41.63 14.28 72.05q2.27 11.4 4.72 23.87c.42 2.08.83 4.17 1.25 6.29a32 32 0 00.71 3.15 13.4 13.4 0 001.35 2.93 13.22 13.22 0 0011 6.31c2.24.11 4.46-.64 6.73-1.09l6.85-1.51 14-3.1 29.26-6.47 62.88-13.92 33.23-7.34c5.62-1.27 11.33-2.45 17-3.8a13.2 13.2 0 009.34-13.09 28.29 28.29 0 00-.64-4.33c-.28-1.45-.55-2.9-.82-4.34-.55-2.89-1.09-5.77-1.64-8.64q-1.62-8.61-3.22-17.1-3.21-17-6.31-33.43l-6.09-32.28q-1.5-7.9-2.95-15.64-.74-3.87-1.45-7.7c-.53-2.54-.76-5.15-1.93-7.39a13.21 13.21 0 00-5.05-5.4 12.35 12.35 0 00-3.42-1.43 13.8 13.8 0 00-1.81-.36 14.09 14.09 0 00-1.84-.07 20.67 20.67 0 00-3.65.5l-3.65.68-7.21 1.35-27.77 5.22-49.85 9.34L120.34 237c-2.13.4-4.15.75-6 1.14a13.44 13.44 0 00-9.79 8.79 12.78 12.78 0 00-.68 5.1 10.87 10.87 0 00.14 1.31c-.01.26-.01.41-.01.41z"
          style={{
            transformOrigin: "213.027px 300.555px 0",
          }}
          id="prefix__elngjxkeetzt"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M307.16 265.26s-.05.19-.18.54-.32.89-.57 1.57c-.13.34-.28.73-.43 1.15a9.66 9.66 0 01-.59 1.36c-.48 1-1 2.09-1.65 3.32s-1.5 2.54-2.48 3.93a46.53 46.53 0 01-3.43 4.33c-.68.72-1.3 1.54-2.09 2.26l-2.37 2.28a57.34 57.34 0 01-5.65 4.33 54.21 54.21 0 01-14.71 7 50 50 0 01-18.55 2c-6.61-.52-13.33-2.56-20-5.16s-13.4-5.79-20.51-8.43c-14.19-5.33-28.66-8-41.8-7.59a83.19 83.19 0 00-18.44 2.5 75.89 75.89 0 00-15.16 5.73 64 64 0 00-18.66 14.11c-.46.52-.91 1-1.31 1.47l-1.08 1.35-.92 1.16-.71 1-1 1.36a4.88 4.88 0 01-.35.45l.3-.48.93-1.39.68-1 .91-1.17c.33-.43.69-.88 1.06-1.37s.84-1 1.3-1.49A63.22 63.22 0 01138.38 286a76.49 76.49 0 0115.22-5.82 82.87 82.87 0 0118.54-2.56c13.21-.4 27.74 2.23 42 7.58 7.13 2.66 13.83 5.86 20.5 8.45s13.32 4.63 19.86 5.15a49.38 49.38 0 0018.39-1.91 54.17 54.17 0 0014.62-6.89 56.59 56.59 0 005.64-4.28l2.37-2.23c.79-.71 1.41-1.52 2.09-2.23a48.34 48.34 0 003.45-4.28c1-1.37 1.74-2.72 2.5-3.89s1.2-2.33 1.69-3.28a10.36 10.36 0 00.61-1.35q.24-.63.45-1.14l.62-1.55c.15-.34.23-.51.23-.51z"
          style={{
            transformOrigin: "210.84px 286.27px 0",
          }}
          id="prefix__eldovdg2krqi9"
          className="prefix__animable"
          fill="#263238"
        />
        <g
          style={{
            transformOrigin: "256.39px 253.3px 0",
          }}
          className="prefix__animable"
          opacity={0.3}
          id="prefix__elfe2vwggif7h"
        >
          <circle
            cx={256.39}
            cy={253.3}
            r={14.2}
            style={{
              transformOrigin: "256.39px 253.3px 0",
            }}
            className="prefix__animable"
            transform="rotate(-45)"
            id="prefix__elxy5zvlo9xc"
          />
        </g>
        <path
          d="M291.2 302.47L269.82 342l1.05.19 15.2 20.72 11.84 2.65c4.38-16.35 8.44-31.12 10.77-42.15a149.9 149.9 0 016.24-21.72z"
          style={{
            transformOrigin: "292.37px 333.625px 0",
          }}
          id="prefix__elpp9luagjmzm"
          className="prefix__animable"
          fill="#c78976"
        />
        <path
          d="M293.75 267.1s-7 9.69-7.92 12.92.32 8 1.56 12.64 3.61 12.19 3.61 12.19l20.91 5.94 2.26-5.62s6.67-14.35 6.84-16.31-1.46-6.06-1.46-6.06 1.68-4.76-.08-6.45a5.76 5.76 0 00-2.87-1.81s3.52-4.05.68-6-4.26-2-4.26-2l-13 14.17s-2.56 2.41-4.6 1.94-2.82-.8-1.32-4.17 2.69-4.39 3.38-7.38-3.73-4-3.73-4z"
          style={{
            transformOrigin: "303.267px 288.665px 0",
          }}
          id="prefix__els3nu1y37bgl"
          className="prefix__animable"
          fill="#c78976"
        />
        <path
          d="M125.73 211.63l-.91 73.3c-.16 12.46 2.16 30.8 21.88 30.15 17.07-1.86 21.59-18 21.73-29.65.06-5.51.12-10.12.17-10.68 0 0 18.68-1.53 20.25-20 .76-8.91.84-27.4.71-44.13a34.48 34.48 0 00-32-34.12l-1.78-.13c-19.29-.27-30.3 15.97-30.05 35.26z"
          style={{
            transformOrigin: "157.212px 245.732px 0",
          }}
          id="prefix__elta395l24z6i"
          className="prefix__animable"
          fill="#c78976"
        />
        <path
          d="M168.6 274.75s-11.69-.17-23.53-8.87c0 0 4.88 13.92 23.43 13.6z"
          style={{
            transformOrigin: "156.835px 272.683px 0",
          }}
          id="prefix__el50ysmvoy2la"
          className="prefix__animable"
          fill="#8b5d54"
        />
        <path
          d="M158 218.2c-.37.37-2.5-1.35-5.59-1.43s-5.4 1.43-5.73 1c-.16-.18.23-.86 1.23-1.57a7.77 7.77 0 014.6-1.3 7.42 7.42 0 014.43 1.61c.95.82 1.26 1.49 1.06 1.69z"
          style={{
            transformOrigin: "152.352px 216.573px 0",
          }}
          id="prefix__el8medpv16px4"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M157.92 224.59a2.49 2.49 0 01-2.58 2.34 2.4 2.4 0 01-2.41-2.44 2.51 2.51 0 012.59-2.34 2.39 2.39 0 012.4 2.44z"
          style={{
            transformOrigin: "155.425px 224.54px 0",
          }}
          id="prefix__elk78ijh74sff"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M165.76 239.7c0-.16 1.79-.34 4.67-.5.73 0 1.43-.11 1.59-.6a3.77 3.77 0 00-.33-2.18c-.56-1.8-1.13-3.69-1.74-5.68-2.4-8.07-4.09-14.69-3.76-14.78s2.54 6.37 4.94 14.45c.57 2 1.12 3.88 1.65 5.7A4.28 4.28 0 01173 239a1.83 1.83 0 01-1.27 1 4.66 4.66 0 01-1.25.08c-2.93-.08-4.72-.22-4.72-.38z"
          style={{
            transformOrigin: "169.457px 228.025px 0",
          }}
          id="prefix__elc5hggj5hfu"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M156.7 206.57c-.3.69-2.77.17-5.73.33s-5.4.8-5.75.14c-.15-.31.31-.95 1.32-1.56a9.43 9.43 0 014.34-1.22 9.18 9.18 0 014.4.87c1.05.53 1.55 1.12 1.42 1.44z"
          style={{
            transformOrigin: "150.956px 205.79px 0",
          }}
          id="prefix__elm6emehi0uy8"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M186.06 212.3c-.32.56-2.74-.06-5.66-.15s-5.35.28-5.66-.3c-.13-.28.35-.78 1.37-1.22a10.07 10.07 0 014.32-.72 10.61 10.61 0 014.3 1.06c1.01.53 1.47 1.03 1.33 1.33z"
          style={{
            transformOrigin: "180.402px 211.213px 0",
          }}
          id="prefix__el5retslvamwu"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M126.24 225.42c-.31-.16-12.42-4.68-12.93 8s12.29 10.57 12.33 10.2.6-18.2.6-18.2z"
          style={{
            transformOrigin: "119.768px 234.243px 0",
          }}
          id="prefix__elb38h78jxj5h"
          className="prefix__animable"
          fill="#c78976"
        />
        <path
          d="M122 238.64c-.06 0-.23.15-.61.3a2.23 2.23 0 01-1.65 0c-1.32-.55-2.35-2.72-2.32-5a7.29 7.29 0 01.74-3.13 2.55 2.55 0 011.73-1.62 1.12 1.12 0 011.28.65c.15.36.06.61.13.64s.28-.2.2-.73a1.38 1.38 0 00-.47-.81 1.65 1.65 0 00-1.2-.38 3.11 3.11 0 00-2.39 1.87 7.44 7.44 0 00-.9 3.5c0 2.55 1.18 5 3 5.59a2.34 2.34 0 002-.25c.39-.27.46-.6.46-.63z"
          style={{
            transformOrigin: "119.27px 234.097px 0",
          }}
          id="prefix__el80tqkmqkcnd"
          className="prefix__animable"
          fill="#8b5d54"
        />
        <path
          d="M162.77 248.46c.14-.32-2.34-1.06-4.08-3.39a14.26 14.26 0 01-1.75-3.3c-.37-.92-.65-1.5-.79-1.45s-.09.66.11 1.66a9.25 9.25 0 001.63 3.7 7.5 7.5 0 003.23 2.47c.97.39 1.62.42 1.65.31z"
          style={{
            transformOrigin: "159.423px 244.416px 0",
          }}
          id="prefix__elscow9vqzbd"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M214.06 194.07a3 3 0 00-1.4-1.74c-1.44-.86-3.11-.74-4.72-.77a26.62 26.62 0 01-13.87-4.22 62 62 0 00-6.46-7.82c-5.59-5.77-10.19-9.69-15-11.61-6.16-2.48-16.46-3.48-22.88-1.8S137.6 173 136.7 179.58c-3.6-3-9-3-13.39-1.25l-.11-.05c-4.88 1.74-7.65 6.9-9.09 11.88s-2.06 10.3-4.7 14.77c-.55.93-1.2 2-.72 3a2.05 2.05 0 002.15.94 6 6 0 002.28-1c-.55 1.3-1.09 2.61-1.64 3.91a11.55 11.55 0 005.32-.35 111.69 111.69 0 003.47 13.13c2 0 3.91.14 5.17 1.27 1.71 1.54 2.47 4.43 5.31 3.34 1.45-.56 2.77-3.6 3.26-5.07a72.07 72.07 0 003.11-30.48 23.22 23.22 0 017.15-5.16l-.22.19c5.16-1.79 11-3.55 15.88-1.13 3.8 1.88 6 5.82 8.87 9a29 29 0 0020.64 9.48c.28 5.19-.16 12.54.11 17.73l4.37-8.32c.36-.61.65-1.22.94-1.84l.1-.18a28.82 28.82 0 011.46-2.95c2.81 2.48 7-1.31 4.74-4.34a7.35 7.35 0 00-1.57-1.58 5.13 5.13 0 004.89 1.27 4 4 0 002.85-4 3.43 3.43 0 00-2-2.75 11.61 11.61 0 006.58-1.45c1.32-.66 2.59-1.88 2.15-3.52z"
          style={{
            transformOrigin: "161.336px 197.344px 0",
          }}
          id="prefix__elibnl403s2m"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M142.51 181.7a17.23 17.23 0 00-1.85 1.69 13.17 13.17 0 00-2.83 6.13 23.35 23.35 0 00-.47 4.69c0 1.7.13 3.52.26 5.44a48.12 48.12 0 01.13 6 20.76 20.76 0 01-.41 3.2A6.63 6.63 0 01136 212a2.79 2.79 0 01-2.61.88 4.17 4.17 0 01-2.34-1.32 9.54 9.54 0 01-1.78-4.7l.39.05a15.89 15.89 0 01-2.25 3.87 5.53 5.53 0 01-3.59 1.95 3.6 3.6 0 01-1.9-.33 3.09 3.09 0 01-1.3-1.28 3.17 3.17 0 01-.39-1.63 2.34 2.34 0 01.59-1.44l.2.18a11.91 11.91 0 01-4 3 11.59 11.59 0 01-1.23.48l-.44.11a2.4 2.4 0 01.41-.18c.28-.11.69-.28 1.19-.53a12.27 12.27 0 003.83-3l.2.17a2.37 2.37 0 00-.13 2.74 2.77 2.77 0 001.17 1.13 3.24 3.24 0 001.73.28 5.16 5.16 0 003.33-1.86 15.09 15.09 0 002.16-3.78l.27-.59.12.64a9.34 9.34 0 001.69 4.48 3.74 3.74 0 002.1 1.19 2.36 2.36 0 002.22-.75 6.37 6.37 0 001.2-2.89 21.31 21.31 0 00.41-3.13 49.45 49.45 0 00-.11-6c-.12-1.92-.24-3.75-.22-5.47a23.08 23.08 0 01.53-4.75 13 13 0 013-6.18 7.43 7.43 0 012.06-1.64z"
          style={{
            transformOrigin: "128.93px 197.315px 0",
          }}
          id="prefix__el462jlfpyue4"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M199.61 199.66l-.15.13-.46.33a5.93 5.93 0 01-.78.5 8.23 8.23 0 01-1.12.59 16.35 16.35 0 01-7.9 1.43 21 21 0 01-11.14-4.12 36 36 0 01-9.57-11c-1.35-2.23-2.44-4.52-3.65-6.64a24.35 24.35 0 00-4.12-5.62 12.62 12.62 0 00-5.32-3.26 9 9 0 00-2.8-.32 10 10 0 00-2.57.49 10.89 10.89 0 00-3.85 2.32 10.6 10.6 0 00-2.08 2.7 12.26 12.26 0 00-.95 2.77v-.19c0-.12.05-.34.09-.57a9.11 9.11 0 01.7-2.08 10.33 10.33 0 012.06-2.8 10.7 10.7 0 013.92-2.43 10.22 10.22 0 012.65-.54 9.51 9.51 0 012.92.31A12.82 12.82 0 01161 175a24.44 24.44 0 014.21 5.69c1.22 2.13 2.32 4.42 3.65 6.63a36.13 36.13 0 009.43 10.93 20.79 20.79 0 0010.92 4.13 16.61 16.61 0 007.82-1.27 24.51 24.51 0 002.58-1.45z"
          style={{
            transformOrigin: "171.38px 187.009px 0",
          }}
          id="prefix__elz6pbln4gte"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M201.29 191.55a2.79 2.79 0 01-.66.46 14.93 14.93 0 01-2 1 20.27 20.27 0 01-3.11 1 21.57 21.57 0 01-4 .52 22 22 0 01-4-.27 19.44 19.44 0 01-3.16-.82 12.75 12.75 0 01-2-.87 3.25 3.25 0 01-.69-.41c0-.08 1.05.45 2.8 1a21.81 21.81 0 003.13.72 23.3 23.3 0 003.92.23 24 24 0 003.9-.48 21.48 21.48 0 003.07-.92c1.77-.64 2.76-1.23 2.8-1.16z"
          style={{
            transformOrigin: "191.48px 193.04px 0",
          }}
          id="prefix__elrf3mkhppuqm"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M186.2 219.36c-.37.37-2.5-1.34-5.59-1.42s-5.4 1.43-5.72 1c-.16-.18.22-.86 1.23-1.57a7.8 7.8 0 014.59-1.3 7.49 7.49 0 014.44 1.61c.93.81 1.23 1.51 1.05 1.68z"
          style={{
            transformOrigin: "180.552px 217.739px 0",
          }}
          id="prefix__el67kp4kjf4g9"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M185.69 225.49a2.5 2.5 0 01-2.59 2.34 2.4 2.4 0 01-2.4-2.44 2.49 2.49 0 012.58-2.34 2.4 2.4 0 012.41 2.44z"
          style={{
            transformOrigin: "183.195px 225.44px 0",
          }}
          id="prefix__elw2lx7wlncc"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M77.65 325.19s-13.19 74.88-12.55 81.88 4.14 18.14 12.1 20.05a35 35 0 0015.27 0l-9.55-92z"
          style={{
            transformOrigin: "78.7737px 376.576px 0",
          }}
          id="prefix__eldyk9o4w48y6"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M184.27 292.62L174 289.71l-2-8.12s-12.72-9.39-33.7-9.66c-6.46-.09-15.59 2.45-20.69 6.41l-1.33 8.23S100.47 297.79 97 301.09c-14.58 13.79-17.64 19.44-19.33 24.1s10.1 113.08 10.1 113.08l2.4 18.94 110-.53.75-96z"
          style={{
            transformOrigin: "139.212px 364.569px 0",
          }}
          id="prefix__el1rfn9bsrpl3"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M171.88 292.9s12.35-.66 14 .23a178.58 178.58 0 0125.54 16.65c11.51 9.21 44.31 30.29 44.31 30.29s4.55-4.38 8.77.61l9.48-7.59s24.35 9.24 28.19 27.66c0 0 1.34 7.32-6.33 11.37 0 0-20.37 18.22-36.85 16.45-17.41-1.86-56.38-20.09-58.33-20.85l-26.86-11.89s-16.5-31.46-9.21-47.2z"
          style={{
            transformOrigin: "232.495px 340.678px 0",
          }}
          id="prefix__elbuqgkxhfrkj"
          className="prefix__animable"
          fill="#ff725e"
        />
        <path
          d="M264.25 357a8.78 8.78 0 01-.82-2.36 24.1 24.1 0 01-.67-6 23.72 23.72 0 01.85-6 8.89 8.89 0 01.88-2.34 20.19 20.19 0 01-.54 2.42 28.82 28.82 0 00-.7 5.91 29.22 29.22 0 00.52 5.93 24.11 24.11 0 01.48 2.44z"
          style={{
            transformOrigin: "263.624px 348.65px 0",
          }}
          id="prefix__el0uyra65kknvr"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M174 289.71a4.21 4.21 0 01-.58-.12l-1.64-.44c-1.43-.36-3.51-.86-6.1-1.35a169.5 169.5 0 00-20.44-2.52 140.19 140.19 0 00-20.58.06c-2.63.23-4.74.56-6.19.82l-1.66.33a2.37 2.37 0 01-.59.08 2.85 2.85 0 01.56-.18l1.66-.42a54.72 54.72 0 016.18-1 125.09 125.09 0 0120.65-.2 151.87 151.87 0 0120.48 2.66c2.59.54 4.66 1.09 6.08 1.51l1.62.52a2.27 2.27 0 01.55.25z"
          style={{
            transformOrigin: "145.11px 287.074px 0",
          }}
          id="prefix__elmygjo4odztc"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M130.9 284.07a36.77 36.77 0 01-1.16-8.34 36.77 36.77 0 011.16 8.34z"
          style={{
            transformOrigin: "130.32px 279.9px 0",
          }}
          id="prefix__elrvfynsou7h"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M135 283.72a10.08 10.08 0 01-1-4.14 9.92 9.92 0 01.39-4.24c.15 0-.07 1.9.1 4.2s.68 4.14.51 4.18z"
          style={{
            transformOrigin: "134.479px 279.53px 0",
          }}
          id="prefix__el7391ecs49nv"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M233.5 381.24a3.65 3.65 0 01-.57-.15l-1.6-.51c-1.38-.47-3.37-1.19-5.8-2.14-4.86-1.89-11.5-4.69-18.79-7.87s-13.85-6.17-18.58-8.36l-5.59-2.62-1.51-.74a2.08 2.08 0 01-.51-.29 3.57 3.57 0 01.55.2l1.55.65 5.65 2.48 18.64 8.23c7.28 3.19 13.9 6 18.72 8 2.41 1 4.37 1.76 5.73 2.28l1.57.6a2.46 2.46 0 01.54.24z"
          style={{
            transformOrigin: "207.025px 369.9px 0",
          }}
          id="prefix__elxngzkz28sfk"
          className="prefix__animable"
          fill="#263238"
        />
        <g
          style={{
            transformOrigin: "143.23px 286.738px 0",
          }}
          className="prefix__animable"
          opacity={0.3}
          id="prefix__el764usleybjg"
        >
          <path
            d="M116.61 286.48c17.33 3.06 34.9 0 53.24 2.2-17.71-3.67-36.15-5.41-53.24-2.2"
            id="prefix__el7dnyqu5lnjk"
            style={{
              transformOrigin: "143.23px 286.738px 0",
            }}
            className="prefix__animable"
          />
        </g>
        <g
          style={{
            transformOrigin: "82.1307px 390.55px 0",
          }}
          className="prefix__animable"
          opacity={0.3}
          id="prefix__el8k3cp5vf90n"
        >
          <path
            d="M86.2 427.26c-9.75-22.83-8.59-48.63-7.27-73.42z"
            id="prefix__elz1ltq6hqa7"
            style={{
              transformOrigin: "82.1307px 390.55px 0",
            }}
            className="prefix__animable"
          />
        </g>
        <path
          d="M77.65 341.52a1.5 1.5 0 010 .29c0 .21.06.49.1.84.08.78.2 1.88.35 3.27.28 2.88.69 7 1.19 12 1 10.15 2.34 24.19 4 39.67s3.24 29.49 4.53 39.61c.63 5.06 1.18 9.16 1.56 12 .19 1.39.33 2.48.43 3.26 0 .35.08.63.1.85a1.27 1.27 0 010 .29 1.24 1.24 0 01-.07-.28c0-.22-.08-.5-.14-.84-.13-.78-.3-1.87-.52-3.25-.45-2.82-1-6.9-1.73-12-1.38-10.12-3-24.12-4.66-39.61S79.9 368.14 79 358c-.43-5.06-.78-9.16-1-12-.11-1.4-.2-2.49-.26-3.28v-.85a1.07 1.07 0 01-.09-.35z"
          style={{
            transformOrigin: "83.7842px 397.56px 0",
          }}
          id="prefix__elz3r2meii2qe"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M152.62 329.27a5 5 0 01-.71 0h-2c-1.77 0-4.34 0-7.51.09-6.35.15-15.11.61-24.72 1.75s-18.25 2.75-24.45 4.1c-3.1.68-5.6 1.25-7.33 1.68l-2 .46a3.6 3.6 0 01-.7.13 5.34 5.34 0 01.68-.22l2-.56c1.71-.48 4.2-1.11 7.3-1.82a234.52 234.52 0 0124.46-4.26 232.14 232.14 0 0124.77-1.6c3.18 0 5.75 0 7.52.06l2 .08a3.25 3.25 0 01.69.11z"
          style={{
            transformOrigin: "117.91px 333.25px 0",
          }}
          id="prefix__el0mvixfcqxyqn"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M110.1 353.51c-.14 0 .12-10.37.56-23.15s.93-23.15 1.06-23.15-.12 10.38-.57 23.16-.92 23.15-1.05 23.14z"
          style={{
            transformOrigin: "110.908px 330.36px 0",
          }}
          id="prefix__el83cdogxp4ka"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M166.69 352.23a4.73 4.73 0 01-.41-.65c-.28-.47-.65-1.11-1.11-1.91l-4.09-7a60.85 60.85 0 01-5.08-10.94 35.94 35.94 0 01-1.52-7 42.65 42.65 0 010-7.67 40.83 40.83 0 013.66-14.29 23.5 23.5 0 013.6-5.38 20.86 20.86 0 014.33-3.62 16.48 16.48 0 017.69-2.57 10.63 10.63 0 013 .16c0 .07-1.06-.13-3 0a16.79 16.79 0 00-7.51 2.67 20.33 20.33 0 00-4.21 3.6 23.14 23.14 0 00-3.51 5.3 41 41 0 00-3.57 14.14 42.61 42.61 0 000 7.58 35.76 35.76 0 001.48 6.89 62.79 62.79 0 005 10.89l4 7.1 1 1.95a4 4 0 01.25.75z"
          style={{
            transformOrigin: "165.534px 321.694px 0",
          }}
          id="prefix__ela1p9zr0778"
          className="prefix__animable"
          fill="#263238"
        />
        <g
          style={{
            transformOrigin: "180.824px 359.01px 0",
          }}
          className="prefix__animable"
          opacity={0.3}
          id="prefix__el442iw5r1t94"
        >
          <path
            d="M160.91 341.44c-1.36 9.54 5.55 15.87 13.48 21.33a114.13 114.13 0 0026.39 13.81l.13-8.75s-11.61-4.79-22.23-10.2c-5.77-2.95-12.38-6.11-14.29-9.52z"
            id="prefix__el4d63z5sg8i1"
            style={{
              transformOrigin: "180.824px 359.01px 0",
            }}
            className="prefix__animable"
          />
        </g>
        <path
          d="M254.47 357.66A10.67 10.67 0 01254 355a33.57 33.57 0 011-12.79 11.11 11.11 0 01.92-2.51 21.82 21.82 0 01-.58 2.6 45.11 45.11 0 00-1 6.31 46.21 46.21 0 00-.06 6.39 23.93 23.93 0 01.19 2.66z"
          style={{
            transformOrigin: "254.851px 348.68px 0",
          }}
          id="prefix__ela361ovi4a9i"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M295.87 372.54a2.87 2.87 0 01-.17-.43c-.11-.33-.25-.74-.41-1.23s-.38-1.2-.67-1.95-.58-1.61-1-2.53L293 365c-.24-.5-.5-1-.76-1.54-.5-1.07-1.16-2.16-1.81-3.33a65.19 65.19 0 00-4.94-7.11 71.6 71.6 0 00-5.88-6.39 69.53 69.53 0 00-5.37-4.62c-.78-.64-1.53-1.16-2.18-1.64s-1.21-.87-1.68-1.18l-1.07-.75c-.24-.17-.37-.27-.36-.29a1.92 1.92 0 01.41.21l1.12.67c.49.28 1.08.66 1.74 1.12s1.43 1 2.23 1.58a62.31 62.31 0 015.47 4.58 66.75 66.75 0 016 6.4 61.61 61.61 0 014.95 7.2c.64 1.18 1.29 2.28 1.78 3.37.26.54.52 1.06.74 1.56l.61 1.48c.41.93.68 1.81.94 2.57a17.14 17.14 0 01.6 2c.13.5.24.92.32 1.27a1.37 1.37 0 01.01.38z"
          style={{
            transformOrigin: "282.414px 355.345px 0",
          }}
          id="prefix__elh75ibv24lsb"
          className="prefix__animable"
          fill="#263238"
        />
        <g
          style={{
            transformOrigin: "264.776px 349.515px 0",
          }}
          className="prefix__animable"
          opacity={0.3}
          id="prefix__elfprzyw58rpa"
        >
          <path
            d="M266.68 354.57a23.19 23.19 0 00-1.06-4.15 31.4 31.4 0 01-1.13-9.74 20.78 20.78 0 00.66 17.67 4.07 4.07 0 001.53-3.78z"
            id="prefix__elhaxzkd4svim"
            style={{
              transformOrigin: "264.776px 349.515px 0",
            }}
            className="prefix__animable"
          />
        </g>
        <g
          style={{
            transformOrigin: "115.17px 336.774px 0",
          }}
          className="prefix__animable"
          opacity={0.3}
          id="prefix__elbt8q0xj8f14"
        >
          <path
            d="M85 337.48a131.34 131.34 0 0020.81-2.75 31.47 31.47 0 00-1.21 9.27 21.38 21.38 0 004.62-8.51 12.9 12.9 0 005.25 8.61 28.28 28.28 0 00.47-9.49q15.53-1.86 30.86-5.1a209.13 209.13 0 00-61.26 7.62"
            id="prefix__elaruf29m93gu"
            style={{
              transformOrigin: "115.17px 336.774px 0",
            }}
            className="prefix__animable"
          />
        </g>
      </g>
      <defs>
        <filter id="prefix__active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="prefix__hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="red" floodOpacity={0.5} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" />
        </filter>
      </defs>
    </svg>
  );
}

export default AnimatedWorker;
